import * as models from './models.v2.3.0.js';
import * as utils from './utils.js';

// Debug the models import
if (typeof models !== 'undefined') {
  //console.log('Models imported successfully:', Object.keys(models));
} else {
  console.error('Models import failed');
}

// my SSL proxy caches the script, so I used this to validate it was updating
// console.log('v9');

let baseURL = 'https://flair.co/';
let currentStep = 1;
let currentFloorIndex = 0;
let lastNon99Step = 1;
let floorData = {
  4: 1, // Current floor in Step 4
  5: 1, // Current floor in Step 5
  9: 1  // Current floor in Step 9
};

const DEBUG = false; // Set to false to disable debug messages
const MOCK_EMAIL_SUBMIT = false; // Set to true to mock email submission

const maxFloors = 3; // Define how many floors are available

const LINK_LIVE_CHAT = 'https://static.zdassets.com/web_widget/latest/liveChat.html?v=10#key=flair.zendesk.com';
const LINK_EMAIL_US  = 'https://support.flair.co/hc/en-us/requests/new';
const KLAVIYO_SUBSCRIPTION_URL = 'https://a.klaviyo.com/client/subscriptions?company_id=SWCXvJ';
const KLAVIYO_PROFILE_URL = 'https://a.klaviyo.com/client/profiles?company_id=SWCXvJ';
const KLAVIYO_LIST = 'XzBfin';

// Instantiate a Structure object
let structure = new models.Structure();

function closeStepper() {
  gtag('event', 'solutionBuilder.close');
  if(DEBUG) {
    console.log(new Error().stack);
  }
  // const container = document.querySelector('.container');
  // container.style.display = 'none';
  // // document.getElementById('open-wizard-button').style.display = 'block';
  // removeOverlay(); // Remove the overlay when the wizard is closed
  // enablePageInteraction(); // Enable page interaction when the wizard is closed

  // // make sure to show the livechat button if had it hidden on mobile
  _showLiveChatButton();
}

function openStepper() {
  gtag('event', 'solutionBuilder.open');
  if(DEBUG) {
    console.log(new Error().stack);
  }
  // const container = document.querySelector('.container');
  // container.style.display = 'block';
  // container.scrollIntoView();
  // container.classList.add('expand-animation');
  // container.addEventListener('animationend', () => {
  //   container.classList.remove('expand-animation');
  // }, { once: true });
  // // document.getElementById('open-wizard-button').style.display = 'none';
  // addOverlay(); // Add the overlay when the wizard is opened
  // disablePageInteraction(); // Disable page interaction when the wizard is opened
  // promptResumeOrStartOver(); // Move the prompt here

  if (window.innerWidth < 840) {
    _hideLiveChatButton();
  }
}

function addOverlay() {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  let overlay = document.querySelector('.overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.classList.add('overlay');
    overlay.style.pointerEvents = 'auto'; // Allow interactions with elements above the overlay
    document.body.appendChild(overlay);
  }
}

function removeOverlay() {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  const overlay = document.querySelector('.overlay');
  if (overlay) overlay.remove();
}

function disablePageInteraction() {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  document.body.style.overflow = 'hidden';
  document.body.style.pointerEvents = 'auto';
  const container = document.querySelector('.container');
  container.style.pointerEvents = 'auto';
}

function enablePageInteraction() {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  document.body.style.overflow = '';
  document.body.style.pointerEvents = '';
}

function updateOpenWizardButton() {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  const openWizardButton = document.getElementById('open-wizard-button');
  if (currentStep > 1) {
    openWizardButton.textContent = 'Resume Wizard';
  } else {
    openWizardButton.textContent = 'Open Wizard';
  }
}

function analyticsTooltip(tag, action=null, step=currentStep) {
  gtag('event', 'solutionBuilder.tooltip', {
    'step': step,
    'steptext': convertStepToText(step),
    'action': action,
    'tooltip-element-id': tag
  });
}

function populateTooltipEvents() {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  // step-1
  document.querySelectorAll('#tooltip-comfort').forEach(tooltip => {
    tooltip.addEventListener('click', () => {
      analyticsTooltip(tooltip.id);
      showTooltip('Making rooms comfortable', 'Flair makes rooms comfortable by automatically adjusting airflow in each room based on your temperature preferences.');
    });
  });
  document.querySelectorAll('#tooltip-energy').forEach(tooltip => {
    tooltip.addEventListener('click', () => {
      analyticsTooltip(tooltip.id);
      showTooltip('Using less energy', 'Flair systems can save up to 30% on your utility bills by using energy more efficiently. Heat or cool the rooms when you want, where you want to the comfort level you desire.');
    });
  });  
  document.querySelectorAll('#tooltip-control').forEach(tooltip => {
    tooltip.addEventListener('click', () => {
      analyticsTooltip(tooltip.id);
      showTooltip('More convenient control', 'Flair provides more convenient control with a user-friendly app that lets you adjust settings remotely and set schedules to fit your lifestyle.');
    });
  });

  // step-2
  document.querySelectorAll('#tooltip-ducted').forEach(tooltip => {
    tooltip.addEventListener('click', () => {
      document.body.style.pointerEvents = 'auto';
      analyticsTooltip(tooltip.id);
      Swal.fire({
        title: 'Ducted',
        html: `<img src="${SB_IMG_URLS['Solution-Builder-Ducted.min.png']}" width="100%" /><br /><span class="button-subtext">A central heating/cooling system uses ducts and vents to heat and cool your home. You likely have a central system if you see vents in your floor, wall and/or ceiling. This is the most common system in North American homes.</span>`,
        allowOutsideClick: false,
        showCloseButton: true,
        showConfirmButton: false,
      });
    });
  });
  document.querySelectorAll('#tooltip-ductless').forEach(tooltip => {
    tooltip.addEventListener('click', () => {
      document.body.style.pointerEvents = 'auto';
      analyticsTooltip(tooltip.id);
      Swal.fire({
        title: 'Ductless',
        html: `<img src="${SB_IMG_URLS['Solution-Builder-Ductless.min.png']}" width="100%" /><br /><span class="button-subtext">A ductless heating/cooling system heats and cools specific areas in your home. You likely have a ductless system if you see wall/window mounted or portable units in your home.</span>`,
        allowOutsideClick: false,
        showCloseButton: true,
        showConfirmButton: false,
      });
    });
  });
  document.querySelectorAll('#tooltip-climate-control-systems').forEach(tooltip => {
    tooltip.addEventListener('click', () => {
      document.body.style.pointerEvents = 'auto';
      analyticsTooltip(tooltip.id);
      Swal.fire({
        title: 'Not sure? ',
        html: `We'll help you figure it out<br /><span class="button-subtext">Unsure about the type of heating/cooling equipment in your home? Reach out to our team for expert guidance.</span>`,
        allowOutsideClick: false,
        showCloseButton: true,
        showDenyButton: true,
        confirmButtonColor: "#ff955a",
        denyButtonColor: "#ff955a",
        confirmButtonText: 'Live Chat',
        denyButtonText: 'Email Us'
      }).then((result) => {
        if (result.isConfirmed) {
          analyticsTooltip(tooltip.id, 'Live Chat');
          // identify user as having clicked this button
          structure.clicked_live_chat = true;
          saveStructureToLocalStorage();

          openLiveChat();
        } else if (result.isDenied) {
          analyticsTooltip(tooltip.id, 'Email Us');
          // identify user as having clicked this button
          structure.clicked_email_us = true;
          saveStructureToLocalStorage();

          window.open(LINK_EMAIL_US, '_blank');
        }
      });
    });
  });

  // step-3
  document.querySelectorAll('#tooltip-ducted-vents').forEach(tooltip => {
    tooltip.addEventListener('click', () => {
      document.body.style.pointerEvents = 'auto';
      analyticsTooltip(tooltip.id);
      Swal.fire({
        title: 'Include rooms that have a thermostat and/or supply vents.',
        html: `<img src="${SB_IMG_URLS['Solution-Builder-Ducted.min.png']}" width="100%" /><br /><span class="button-subtext">Supply vents deliver hot and cold air into a room-supply vents blow air out. Include room(s) with thermostat(s) in the room count, even if they don't have supply vents.</span>`,
        allowOutsideClick: false,
        showCloseButton: true,
        showConfirmButton: false,
      });
    });
  });
  document.querySelectorAll('#tooltip-ducted-floors').forEach(tooltip => {
    tooltip.addEventListener('click', () => {
      document.body.style.pointerEvents = 'auto';
      analyticsTooltip(tooltip.id);
      Swal.fire({
        title: 'Floors',
        html: `Include all floors with rooms that are a part of your central heating and cooling system.`,
        allowOutsideClick: false,
        showCloseButton: true,
        showConfirmButton: false,
      });
    });
  });
  document.querySelectorAll('#tooltip-ducted-rooms').forEach(tooltip => {
    tooltip.addEventListener('click', () => {
      document.body.style.pointerEvents = 'auto';
      analyticsTooltip(tooltip.id);
      Swal.fire({
        title: 'Rooms',
        html: `Include all rooms on each floor that are part of your heating and cooling system.<br /><br />Be sure to include room(s) with thermostat(s) in the room count, even if they don't have supply vents.`,
        allowOutsideClick: false,
        showCloseButton: true,
        showConfirmButton: false,
      });
    });
  });
  document.querySelectorAll('#tooltip-ducted-more-floors').forEach(tooltip => {
    tooltip.addEventListener('click', () => {
      document.body.style.pointerEvents = 'auto';
      analyticsTooltip(tooltip.id);
      Swal.fire({
        title: 'Unique Home?',
        html: `<span class="button-subtext">Reach out to our team for a customized recommendation tailored to your specific needs. Flair's solutions are flexible, supporting single room through to large full-home installations.</span>`,
        allowOutsideClick: false,
        showCloseButton: true,
        showDenyButton: true,
        confirmButtonColor: "#ff955a",
        denyButtonColor: "#ff955a",
        confirmButtonText: 'Live Chat',
        denyButtonText: 'Email Us'
      }).then((result) => {
        if (result.isConfirmed) {
          analyticsTooltip(tooltip.id, 'Live Chat');
          // identify user as having clicked this button
          structure.clicked_live_chat = true;
          saveStructureToLocalStorage();

          openLiveChat();
        } else if (result.isDenied) {
          analyticsTooltip(tooltip.id, 'Email Us');
          // identify user as having clicked this button
          structure.clicked_email_us = true;
          saveStructureToLocalStorage();

          window.open(LINK_EMAIL_US, '_blank');
        }
      });
    });
  });

  // step-4
  setTimeout(() => {
    document.querySelectorAll('#tooltip-ducted-thermostat').forEach(tooltip => {
      tooltip.addEventListener('click', () => {
        document.body.style.pointerEvents = 'auto';
        Swal.fire({
          title: 'Thermostat',
          html: `Current device used to control the heating and cooling system in your home. Typically, mounted on the wall.<br />
          <br />
          Only select the room of where the thermostat is actually located. This is to help determine if your home has more than one ducted system.`,
          allowOutsideClick: false,
          showCloseButton: true,
          showConfirmButton: false,
        });
      });
    });

    document.querySelectorAll('#tooltip-ducted-remote-sensor').forEach(tooltip => {
      tooltip.addEventListener('click', () => {
        document.body.style.pointerEvents = 'auto';
        Swal.fire({
          title: 'Remote Sensor',
          html: `These are additional devices that use a compatible thermostat's remote temperature sensor to get temperature readings from rooms other than where the thermostat is located.`,
          allowOutsideClick: false,
          showCloseButton: true,
          showConfirmButton: false,
        });
      });
    });
  }, 500);

  // step-9
  document.querySelectorAll('#tooltip-ducted-unique-vents').forEach(tooltip => {
    tooltip.addEventListener('click', () => {
      document.body.style.pointerEvents = 'auto';
      analyticsTooltip(tooltip.id);
      Swal.fire({
        title: "Unique Shape or Size?",
        html: `Reach out and let us know as we're always looking to expand into additional sizes.`,
        allowOutsideClick: false,
        showCloseButton: true,
        showDenyButton: true,
        confirmButtonColor: "#ff955a",
        denyButtonColor: "#ff955a",
        confirmButtonText: 'Live Chat',
        denyButtonText: 'Email Us'
      }).then((result) => {
        if (result.isConfirmed) {
          analyticsTooltip(tooltip.id, 'Live Chat');
          // identify user as having clicked this button
          structure.clicked_live_chat = true;
          saveStructureToLocalStorage();

          openLiveChat();
        } else if (result.isDenied) {
          analyticsTooltip(tooltip.id, 'Email Us');
          // identify user as having clicked this button
          structure.clicked_email_us = true;
          saveStructureToLocalStorage();

          window.open(LINK_EMAIL_US, '_blank');
        }
      });
    });
  });

  // step-10
  document.querySelectorAll('#tooltip-have-questions').forEach(tooltip => {
    tooltip.addEventListener('click', () => {
      // identify user as having clicked this button
      structure.clicked_have_questions = true;
      saveStructureToLocalStorage();


      document.body.style.pointerEvents = 'auto';
      analyticsTooltip(tooltip.id);
      Swal.fire({
        title: "Have Questions?",
        html: `We're here to help.<br />Reach out to our team for expert guidance.`,
        allowOutsideClick: false,
        showCloseButton: true,
        showDenyButton: true,
        confirmButtonColor: "#ff955a",
        denyButtonColor: "#ff955a",
        confirmButtonText: 'Live Chat',
        denyButtonText: 'Email Us'
      }).then((result) => {
        if (result.isConfirmed) {
          analyticsTooltip(tooltip.id, 'Live Chat');
          // identify user as having clicked this button
          structure.clicked_live_chat = true;
          saveStructureToLocalStorage();

          openLiveChat();
        } else if (result.isDenied) {
          analyticsTooltip(tooltip.id, 'Email Us');
          // identify user as having clicked this button
          structure.clicked_email_us = true;
          saveStructureToLocalStorage();

          window.open(LINK_EMAIL_US, '_blank');
        }
      });
    });
  });


  // step-13
  document.querySelectorAll('#tooltip-ductless-unsupported').forEach(tooltip => {
    tooltip.addEventListener('click', () => {
      analyticsTooltip(tooltip.id);
      var html;

      if (structure.hvacSystems.some(system => system.systemType === 'ductless-minisplit')) {
        html = `Some of your Ductless units are not fully compatible with Flair. <br /><br />All features and benefits of a Flair Ductless Control Solution may not be available for these units.<br /><br />Have questions?`;
      } else {
        html = `Your Ductless units are not fully compatible with Flair. <br /><br />All features and benefits of a Flair Ductless Control Solution may not be available for these units.<br /><br />Have questions?`;
      }
      
      // update hvacSystems that are not ductless-minisplit to have their supportsRemote set to false
      structure.hvacSystems.forEach(system => {
        if (system.systemType === "ductless-minisplit") {
          system.supportsRemote = true;
        } else {
          system.supportsRemote = false;
        }
      });

      document.body.style.pointerEvents = 'auto';
      Swal.fire({
        title: "Your ductless units aren't fully compatible with Flair.",
        html: html,
        allowOutsideClick: false,
        showCloseButton: true,
        showDenyButton: true,
        confirmButtonColor: "#ff955a",
        denyButtonColor: "#ff955a",
        confirmButtonText: 'Live Chat',
        denyButtonText: 'Email Us'
      }).then((result) => {
        if (result.isConfirmed) {
          analyticsTooltip(tooltip.id, 'Live Chat');
          // identify user as having clicked this button
          structure.clicked_live_chat = true;
          saveStructureToLocalStorage();

          openLiveChat();
        } else if (result.isDenied) {
          analyticsTooltip(tooltip.id, 'Email Us');
          // identify user as having clicked this button
          structure.clicked_email_us = true;
          saveStructureToLocalStorage();

          window.open(LINK_EMAIL_US, '_blank');
        }

        // if mix, just continue and we will add their # minisplits as pucks
        if (structure.hvacSystems.some(system => system.systemType === 'ductless-minisplit')) {
          nextStep(14);
        } else {
          closeStepper();
        }
      });
    });
  });

  // ALL IMAGE ZOOMS
  document.querySelectorAll('.tooltip-image-zoom').forEach(imageZoom => {
    imageZoom.addEventListener('click', () => {
      analyticsTooltip(imageZoom.id, imageZoom.src);
      utils.zoomImage(imageZoom.src);
    });
  });
}

// // Call updateOpenWizardButton initially to set the correct button text
// document.addEventListener('DOMContentLoaded', updateOpenWizardButton);

function updateImagePaths() {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  const isShopify = window.location.hostname.includes('flair');
  const images = document.querySelectorAll('img[data-src]');
  if (isShopify) {
    const imageUrlContainer = document.getElementById('image-url-container');
    const imageUrls = {};
    imageUrlContainer.querySelectorAll('img').forEach(img => {
      const dataSrc = img.getAttribute('data-src');
      const src = img.getAttribute('src');
      imageUrls[dataSrc] = src;
    });

    images.forEach(img => {
      const dataSrc = img.getAttribute('data-src');
      if (imageUrls[dataSrc]) {
        img.setAttribute('src', imageUrls[dataSrc]);
      }
    });
  } else {
    images.forEach(img => {
      const dataSrc = img.getAttribute('data-src');
      img.setAttribute('src', dataSrc);
    });
  }
}


// Call updateImagePaths initially to handle images present at load time
document.addEventListener('DOMContentLoaded', updateImagePaths);

function generateFloorContent(floorIndex) {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  const floor = structure.floors[floorIndex];
  if (!floor) return; // Ensure the floor exists
  const currentFloorContainer = document.getElementById('current-floor-container');
  const nextFloorContainer = document.getElementById('next-floor-container');
  const leftSubContainer = document.querySelector('#step-4 .sub-container.left img');

  // Clear existing content
  currentFloorContainer.innerHTML = '';
  nextFloorContainer.innerHTML = '';

  // Set the image based on the number of floors and the current floor index
  const totalFloors = structure.floors.length;
  const imgURL = SB_IMG_URLS[`Solution-Builder-${totalFloors}-Floors-Floor-${floorIndex + 1}-Highlighted.min.png`];
  leftSubContainer.setAttribute('data-src', imgURL);
  leftSubContainer.setAttribute('src', imgURL);
  updateImagePaths();

  // Generate content for the current floor
  const currentFloorDiv = document.createElement('div');
  currentFloorDiv.classList.add('name-room-hvac');
  currentFloorDiv.innerHTML = (window.innerWidth < 840) ? '' : `<h3 style="font-weight: bold">${floor.name}</h3>`;
  const table = document.createElement('table');
  table.className = '_'; // bass.css requires at least some class be set to override
  const headerRow = document.createElement('tr');
  var roomNameText = (window.innerWidth < 840) ? `<h3 style="font-weight: bold">${floor.name}</h3>` : 'Room Name';
  var thermostatText = (window.innerWidth < 840) ? 'Tstat' : 'Thermostat';
  if (window.innerWidth < 840) {
    headerRow.innerHTML = `
      <th colspan="2" rowspan="2" style="text-align: center; vertical-align: middle;">${roomNameText}</th>
      <th><span class="tooltip-icon" id="tooltip-ducted-thermostat" style="margin-right: 1em;">?</span></th>
      <th><span class="tooltip-icon" id="tooltip-ducted-remote-sensor" style="margin-right: 1em;">?</span></th>
    `;
    table.appendChild(headerRow);
    const headerRow2 = document.createElement('tr');
    headerRow2.innerHTML = `
      <th>${thermostatText}?</th>
      <th>Room<br />Sensor?</th>
    `;
    table.appendChild(headerRow2);
  } else {
    headerRow.innerHTML = `
      <th colspan="2" style="text-align: center; vertical-align: bottom;">${roomNameText}</th>
      <th style="vertical-align: bottom;">${thermostatText}? <span class="tooltip-icon" id="tooltip-ducted-thermostat" style="margin-right: 1em;">?</span></th>
      <th><span class="tooltip-icon" id="tooltip-ducted-remote-sensor" style="margin-right: 1em;">?</span><br />Sensor?</th>
    `;
    table.appendChild(headerRow);
  }
  // <span class="tooltip-icon" onclick="showTooltip('Thermostat', \`Current device used to control the heating and cooling system in your home. Typically, mounted on the wall.<br /><br />Only select the room of where the thermostat is actually located. This is to help determine if your home has more than one ducted system.\`);" style="margin-right: 1em;">?</span>
  // <span class="tooltip-icon" onclick="showTooltip('Remote Sensor', \`These are additional devices that use a compatible thermostat's remote temperature sensor to get temperature readings from rooms other than where the thermostat is located.\`);" style="margin-right: 1em;">?</span>

  // execute tooltip onclick injection
  populateTooltipEvents();

  const possibleRoomNames = [
    'Bedroom (Guest)',
    'Bedroom (Nursery)',
    'Bedroom (Primary)',
    'Bedroom',
    'Den',
    'Dining Room',
    'Garage',
    'Hallway',
    'Kitchen',
    'Bathroom',
    'Laundry',
    'Living Room',
    'Loft',
    'Office',
    'Play/Game Room',
    'Other'
  ]


  floor.rooms.forEach((room, index) => {
    const row = document.createElement('tr');

    var roomOptions = ``;
    possibleRoomNames.forEach(option => {
      roomOptions += `<option value="${option}"${room.name === option ? ' selected' : ''}">${option}</option>\n`;
    });

    row.innerHTML = `
      <td>Room ${index + 1}</td>
      <td>
        <select class="room-name-dropdown">
          ${roomOptions}
        </select>
      </td>
      <td class="hide-on-desktop">
        <input type="checkbox" class="thermostat-checkbox"${room.thermostats.length > 0 ? ' checked' : ''}>
      </td>
      <td class="hide-on-mobile">
        <select class="thermostat-dropdown">
          <option value="No">No</option>
          ${models.Thermostat.ALLOWABLE_BRANDS.map(brand => `<option value="${brand}"${room.thermostats.filter(thermostat => thermostat.name === brand) ? ' selected' : ''}>${brand}</option>`).join('')}
        </select>
      </td>
      <td>
        <input type="checkbox" class="remote-sensor-checkbox"${room.remoteSensors.length > 0 ? ' checked' : ''}>
      </td>
    `;
    table.appendChild(row);

    // Set the initial values based on the structure
    const roomNameDropdown = row.querySelector('.room-name-dropdown');
    roomNameDropdown.value = room.name || '';
    row.querySelector('.thermostat-dropdown').value = room.thermostats.length > 0 ? room.thermostats[0].brand : 'No';
    row.querySelector('.thermostat-checkbox').checked = room.thermostats.length > 0;
    row.querySelector('.remote-sensor-checkbox').checked = room.remoteSensors.length > 0;

    // Add event listeners for room name, thermostat, and remote sensor changes
    roomNameDropdown.addEventListener('change', (event) => {
      room.name = event.target.value;
      saveStructureToLocalStorage();
      prettyPrintStructure();
    });

    row.querySelector('.thermostat-dropdown').addEventListener('change', (event) => {
      const newBrand = event.target.value;
      if (newBrand === 'No') {
        room.thermostats = [];
      } else {
        room.thermostats = [new models.Thermostat(newBrand)];
        // Update remote sensor brands if applicable
        structure.floors.forEach(floor => {
          floor.rooms.forEach(r => {
            r.remoteSensors.forEach(sensor => {
              if (["ecobee", "Nest", "Honeywell Smart", "Sensi"].includes(newBrand)) {
                sensor.setBrand(newBrand);
              }
            });
          });
        });
      }
      saveStructureToLocalStorage();
      prettyPrintStructure();
    });

    row.querySelector('.thermostat-checkbox').addEventListener('change', (event) => {
      if (event.target.checked) {
        // create swal popup to ask what their thermostat is named from models.Thermostat.ALLOWABLE_BRANDS
        // if they cancel, uncheck the box
        Swal.fire({
          title: 'What brand of thermostat do you have?',
          input: 'select',
          inputOptions: models.Thermostat.ALLOWABLE_BRANDS,
          inputPlaceholder: 'Select a brand',
          showCancelButton: false,
          showDenyButton: true,
          confirmButtonColor: "#ff955a",
          // gray deny button
          denyButtonColor: "#8e8e8e",
          confirmButtonText: 'Save',
          denyButtonText: 'Cancel',
          preConfirm: (selectedBrand) => {
            if (!selectedBrand) {
              Swal.showValidationMessage('Please select a brand');
              return false;
            }
            room.thermostats = [new models.Thermostat(models.Thermostat.ALLOWABLE_BRANDS[selectedBrand])];
            // Update remote sensor brands if applicable
            structure.floors.forEach(floor => {
              floor.rooms.forEach(r => {
                r.remoteSensors.forEach(sensor => {
                  if (["ecobee", "Nest", "Honeywell Smart", "Sensi"].includes(selectedBrand)) {
                    sensor.setBrand(selectedBrand);
                  }
                });
              });
            });
            saveStructureToLocalStorage();
            prettyPrintStructure();
          },
        }).then((result) => {
          if (result.isDenied) {
            // uncheck box since they cancel
            event.target.checked = false;
            room.thermostats = [];
            saveStructureToLocalStorage();
            prettyPrintStructure();
          }
        });
      } else {
        room.thermostats = [];
        saveStructureToLocalStorage();
        prettyPrintStructure();
      }
    });

    row.querySelector('.remote-sensor-checkbox').addEventListener('change', (event) => {
      if (event.target.checked) {
        const newSensor = new models.RemoteSensor();
        // Set the brand of the remote sensor if a thermostat with a valid brand exists
        const validThermostat = structure.floors.flatMap(floor => floor.rooms)
          .flatMap(room => room.thermostats)
          .find(thermostat => ["ecobee", "Nest", "Honeywell Smart", "Sensi"].includes(thermostat.getBrand()));
        if (validThermostat) {
          newSensor.setBrand(validThermostat.getBrand());
        }
        room.remoteSensors = [newSensor];
      } else {
        room.remoteSensors = [];
      }
      saveStructureToLocalStorage();
      prettyPrintStructure();
    });
  });

  currentFloorDiv.appendChild(table);
  currentFloorContainer.appendChild(currentFloorDiv);

  // Generate content for the next floor if it exists
  if (floorIndex + 1 < structure.floors.length) {
    const nextFloor = structure.floors[floorIndex + 1];
    const nextFloorDiv = document.createElement('div');
    nextFloorDiv.classList.add('name-room-hvac');
    nextFloorDiv.innerHTML = `<h3>${nextFloor.name}</h3>`;
    const nextTable = document.createElement('table');
    nextTable.className = '_'; // bass.css requires at least some class be set to override
    const nextHeaderRow = document.createElement('tr');
    nextHeaderRow.innerHTML = `
      <th colspan="2" style="text-align: center; padding-left: 2em;">Room Name</th>
      <th>Thermostat?</th>
      <th>Remote Sensor?</th>
    `;
    nextTable.appendChild(nextHeaderRow);

    nextFloor.rooms.forEach((room, index) => {
      var roomOptions = ``;
      possibleRoomNames.forEach(option => {
        roomOptions += `<option value="${option}"${room.name === option ? ' selected' : ''}">${option}</option>\n`;
      });

      const row = document.createElement('tr');
      row.innerHTML = `
        <td>Room ${index + 1}</td>
        <td>
          <select class="room-name-dropdown">
            ${roomOptions}
          </select>
        </td>
        <td>
          <select class="thermostat-dropdown">
            <option value="No">No</option>
            ${models.Thermostat.ALLOWABLE_BRANDS.map(brand => `<option value="${brand}"${room.thermostats.filter(thermostat => thermostat.name === brand) ? ' selected' : ''}>${brand}</option>`).join('')}
          </select>
        </td>
        <td>
          <input type="checkbox" class="remote-sensor-checkbox"${room.remoteSensors.length > 0 ? ' checked' : ''}>
        </td>
      `;
      nextTable.appendChild(row);

      // Set the initial values based on the structure
      const roomNameDropdown = row.querySelector('.room-name-dropdown');
      roomNameDropdown.value = room.name || '';
      row.querySelector('.thermostat-dropdown').value = room.thermostats.length > 0 ? room.thermostats[0].brand : 'No';
      row.querySelector('.remote-sensor-checkbox').checked = room.remoteSensors.length > 0;

      // Add event listeners for room name, thermostat, and remote sensor changes
      roomNameDropdown.addEventListener('change', (event) => {
        room.name = event.target.value;
        saveStructureToLocalStorage();
        prettyPrintStructure();
      });

      row.querySelector('.thermostat-dropdown').addEventListener('change', (event) => {
        const newBrand = event.target.value;
        if (newBrand === 'No') {
          room.thermostats = [];
        } else {
          room.thermostats = [new models.Thermostat(newBrand)];
          // Update remote sensor brands if applicable
          structure.floors.forEach(floor => {
            floor.rooms.forEach(r => {
              r.remoteSensors.forEach(sensor => {
                if (["ecobee", "Nest", "Honeywell Smart", "Sensi"].includes(newBrand)) {
                  sensor.setBrand(newBrand);
                }
              });
            });
          });
        }
        saveStructureToLocalStorage();
        prettyPrintStructure();
      });

      row.querySelector('.remote-sensor-checkbox').addEventListener('change', (event) => {
        if (event.target.checked) {
          const newSensor = new models.RemoteSensor();
          // Set the brand of the remote sensor if a thermostat with a valid brand exists
          const validThermostat = structure.floors.flatMap(floor => floor.rooms)
            .flatMap(room => room.thermostats)
            .find(thermostat => ["ecobee", "Nest", "Honeywell Smart", "Sensi"].includes(thermostat.getBrand()));
          if (validThermostat) {
            newSensor.setBrand(validThermostat.getBrand());
          }
          room.remoteSensors = [newSensor];
        } else {
          room.remoteSensors = [];
        }
        saveStructureToLocalStorage();
        prettyPrintStructure();
      });
    });

    nextFloorDiv.appendChild(nextTable);
    nextFloorContainer.appendChild(nextFloorDiv);
  }
  updateImagePaths();
}

function generateFloorContentStep5(floorIndex) {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  const floor = structure.floors[floorIndex];
  if (!floor) {
    console.error(`Unable to get Floor at index of ${floorIndex}`);
    if(DEBUG) {
      console.error(`Floor at index ${floorIndex} is undefined. Possible reasons:`);
      console.error(`1. The floor index is out of bounds.`);
      console.error(`2. The structure.floors array is not populated correctly.`);
      console.error(`3. The structure object might not be loaded correctly from localStorage.`);
    }
    return; // Ensure the floor exists
  }
  const currentFloorContainer = document.getElementById('current-floor-container-step-5');
  const nextFloorContainer = document.getElementById('next-floor-container-step-5');
  const leftSubContainer = document.querySelector('#step-5 .sub-container.left img');

  // Clear existing content
  currentFloorContainer.innerHTML = '';
  nextFloorContainer.innerHTML = '';

  // Set the image based on the number of floors and the current floor index
  const totalFloors = structure.floors.length;
  const imgURL = SB_IMG_URLS[`Solution-Builder-${totalFloors}-Floors-Floor-${floorIndex + 1}-Highlighted.min.png`];
  leftSubContainer.setAttribute('data-src', imgURL);
  leftSubContainer.setAttribute('src', imgURL);
  updateImagePaths();

  // Generate content for the current floor
  const currentFloorDiv = document.createElement('div');
  currentFloorDiv.classList.add('name-room-hvac');
  currentFloorDiv.innerHTML = `<h3>${floor.name}</h3>`;
  const table = document.createElement('table');
  table.className = '_'; // base.css requires a class name be set, even if its not actually used
  const headerRow = document.createElement('tr');
  headerRow.innerHTML = `
    <th style="width: 10em;"></th>
    <th>When Heating</th>
    <th>When Cooling</th>
  `;
  table.appendChild(headerRow);
  floor.rooms.forEach((room, index) => {
    const row = document.createElement('tr');
    row.innerHTML = `
      <td>${room.name}</td>
      <td>
        <select name="heating-${floorIndex}-${index}" class="when-heating-dropdown">
          ${['-', 'Too hot', 'No issue', 'Too cold'].map(option => `<option value="${option}"${room.heatingBehavior === option ? ' selected' : room.heatingBehavior !== null ? '' : '-'}>${option}</option>`).join('')}
        </select>
      </td>
      <td>
        <select name="cooling-${floorIndex}-${index}" class="when-cooling-dropdown">
          ${['-', 'Too hot', 'No issue', 'Too cold'].map(option => `<option value="${option}"${room.coolingBehavior === option ? ' selected' : room.heatingBehavior !== null ? '' : '-'}>${option}</option>`).join('')}
        </select>
      </td>
    `;
    table.appendChild(row);

    row.querySelector('.when-heating-dropdown').addEventListener('change', (event) => {
      const newBehavior = event.target.value;
      // make sure newBehavior is not -
      if (newBehavior !== '-') {
        room.heatingBehavior = newBehavior;
        saveStructureToLocalStorage();
        prettyPrintStructure();
      } else {
        // throw popup error saying they have to select something other than -
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'You must select a heating option other than "-"!',
        });
      }
    });

    row.querySelector('.when-cooling-dropdown').addEventListener('change', (event) => {
      const newBehavior = event.target.value;
      if (newBehavior !== '-') {
        room.coolingBehavior = newBehavior;
        saveStructureToLocalStorage();
        prettyPrintStructure();
      } else {
        // throw popup error saying they have to select something other than -
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'You must select a cooling option other than "-"!',
        });
      }
    });
  });

  currentFloorDiv.appendChild(table);
  currentFloorContainer.appendChild(currentFloorDiv);

  // Generate content for the next floor if it exists
  if (floorIndex + 1 < structure.floors.length) {
    const nextFloor = structure.floors[floorIndex + 1];
    if (!nextFloor) {
      console.error(`Next floor at index ${floorIndex + 1} is undefined.`);
      return; // Ensure the next floor exists
    }
    const nextFloorDiv = document.createElement('div');
    nextFloorDiv.classList.add('name-room-hvac');
    nextFloorDiv.innerHTML = `<h3>${nextFloor.name}</h3>`;
    const nextTable = document.createElement('table');
    nextTable.className = '_'; // bass.css requires at least some class be set to override
    const nextHeaderRow = document.createElement('tr');
    nextHeaderRow.innerHTML = `
      <th></th>
      <th>When Heating</th>
      <th>When Cooling</th>
    `;
    nextTable.appendChild(nextHeaderRow);

    nextFloor.rooms.forEach((room, index) => {
      const row = document.createElement('tr');
      row.innerHTML = `
        <td>${room.name}</td>
        <td>
          <select name="heating-${floorIndex + 1}-${index}" class="when-heating-dropdown" disabled>
            ${['-', 'Too hot', 'No issue', 'Too cold'].map(option => `<option value="${option}"${room.heatingBehavior === option ? ' selected' : room.heatingBehavior !== null ? '' : '-'}>${option}</option>`).join('')}
          </select>
        </td>
        <td>
          <select name="cooling-${floorIndex + 1}-${index}" class="when-cooling-dropdown" disabled>
            ${['-', 'Too hot', 'No issue', 'Too cold'].map(option => `<option value="${option}"${room.coolingBehavior === option ? ' selected' : room.heatingBehavior !== null ? '' : '-'}>${option}</option>`).join('')}
          </select>
        </td>
      `;
      nextTable.appendChild(row);
    });

    nextFloorDiv.appendChild(nextTable);
    nextFloorContainer.appendChild(nextFloorDiv);
  }
  updateImagePaths();
}

function generateFloorContentStep9(floorIndex) {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  const floor = structure.floors[floorIndex];
  const recommendedFloor = structure.recommendation.floors[floorIndex];
  const currentFloorContainer = document.getElementById('current-floor-container-step-9');
  const nextFloorContainer = document.getElementById('next-floor-container-step-9');
  const leftSubContainer = document.querySelector('#step-9 .sub-container.left img');

  // Clear existing content
  currentFloorContainer.innerHTML = '';
  nextFloorContainer.innerHTML = '';

  // Set the image based on the number of floors and the current floor index
  const totalFloors = structure.floors.length;
  leftSubContainer.src = SB_IMG_URLS[`Solution-Builder-${totalFloors}-Floors-Floor-${floorIndex + 1}-Highlighted.min.png`];

  // Generate content for the current floor
  const currentFloorDiv = document.createElement('div');
  currentFloorDiv.classList.add('name-room-hvac');
  currentFloorDiv.innerHTML = `<h3>${floor.getName()}</h3>`;
  const table = document.createElement('table');
  table.className = '_'; // bass.css requires at least some class be set to override

  // Check if any rooms on the current floor have smart vent recommendations
  const hasCurrentFloorRecommendations = floor.rooms.some((room, index) => {
    const recommendedRoom = recommendedFloor.rooms[index];
    return recommendedRoom && recommendedRoom.smartVentCandidate;
  });

  if (window.innerWidth > 800) {
    const headerRow = document.createElement('tr');
    headerRow.innerHTML = `
      <th>Room</th>
      <th>No.</th>
      <th class="divider"></th>
      <th>Vent 1</th>
      <th>Vent 2</th>
      <th>Vent 3</th>
      <th>Vent 4</th>
      <th>Vent 5</th>
    `;
    table.appendChild(headerRow);

    if(DEBUG) {
      console.log(`rooms>>>`);
      console.log(floor.rooms);
    }

    if (hasCurrentFloorRecommendations) {
      floor.rooms.forEach((room, index) => {
        const recommendedRoom = recommendedFloor.rooms[index];
        if (recommendedRoom.smartVentCandidate) {
          const row = document.createElement('tr');
          let html = `
            <td>${room.getName()}</td>
            <td>
              <select class="vent-count-dropdown">
                <option value=""${room.vent_count === null ? ' selected': ''}>-</option>
                <option value="0"${room.vent_count === 0 ? ' selected': ''}>0</option>
                <option value="1"${room.vent_count === 1 ? ' selected': ''}>1</option>
                <option value="2"${room.vent_count === 2 ? ' selected': ''}>2</option>
                <option value="3"${room.vent_count === 3 ? ' selected': ''}>3</option>
                <option value="4"${room.vent_count === 4 ? ' selected': ''}>4</option>
                <option value="5"${room.vent_count === 5 ? ' selected': ''}>5</option>
              </select>
            </td>
            <td class="divider"></td>`;
          // loop 5 times
          for(let i=0; i<5; i++){
            html += `<td><select class="vent-size-dropdown">`;
            html += `<option value="">-</option>`;
            document.querySelectorAll('[data-product="vent"]').forEach(div => {
              let size = div.getAttribute('data-variant');
              let extraAttributes = ``;
              if (room.vents !== null) {
                if (room.vents.length >= i+1 ) {
                  extraAttributes += room.vents[i].size === size ? ' selected': ''
                }
              }
              html += `<option value="${size}"${extraAttributes}>${size}</option>`;
            });
            html += `</select></td>`;
          }
          row.innerHTML = html;
          table.appendChild(row);

          // Set the initial values based on the structure
          const ventCountDropdown = row.querySelector('.vent-count-dropdown');

          // Show/hide vent size dropdowns based on the vent count
          const ventSizeDropdowns = row.querySelectorAll('.vent-size-dropdown');
          ventSizeDropdowns.forEach((dropdown, i) => {
            dropdown.style.display = i < room.vents.length ? 'block' : 'none';
            if (room.vents[i]) {
              dropdown.value = room.vents[i].getSize();
            }
          });

          // Add event listener for vent count changes
          ventCountDropdown.addEventListener('change', (event) => {
            const count = parseInt(event.target.value, 10);
            structure.floors[floorIndex].rooms[index].vent_count = count;

            structure.floors[floorIndex].rooms[index].vents = Array.from({ length: count }, (_, i) => room.vents[i] || new models.SmartVent());
            ventSizeDropdowns.forEach((dropdown, i) => {
              dropdown.style.display = i < count ? 'block' : 'none';
            });

            // // Update getStartedRecommendation
            // const getStartedRoom = structure.getStartedRecommendation.floors[floorIndex].rooms[index];
            // getStartedRoom.vents = Array.from({ length: count }, (_, i) => getStartedRoom.vents[i] || new models.SmartVent());

            const recommendedRoom = structure.recommendation.floors[floorIndex].rooms[index];
            recommendedRoom.vent_count = count;
            recommendedRoom.vents = Array.from({ length: count }, (_, i) => recommendedRoom.vents[i] || new models.SmartVent());
            
            if(DEBUG) {
              console.log('ventCountDropdown changes... ');
              console.log(room);
            }
            saveStructureToLocalStorage();
          });

          // Add event listeners for vent size changes
          ventSizeDropdowns.forEach((dropdown, i) => {
            dropdown.addEventListener('change', (event) => {
              if (structure.floors[floorIndex].rooms[index].vents[i]) {
                structure.floors[floorIndex].rooms[index].vents[i].setSize(event.target.value);
              }

              // // Update getStartedRecommendation
              // const getStartedRoom = structure.getStartedRecommendation.floors[floorIndex].rooms[index];
              // if (getStartedRoom.vents[i]) {
              //   getStartedRoom.vents[i].setSize(event.target.value);
              // }
              
              const recommendedRoom = structure.recommendation.floors[floorIndex].rooms[index];
              if (recommendedRoom.vents[i]) {
                recommendedRoom.vents[i].setSize(event.target.value);
              }

              saveStructureToLocalStorage();
            });
          });
        }
      });
    } else {
      // No recommendations for current floor - show message with reasoning
      const reasonRow = document.createElement('tr');
      const reasonCell = document.createElement('td');
      reasonCell.colSpan = 8; // Span all columns
      reasonCell.style.textAlign = 'center';
      reasonCell.style.padding = '20px';
      
      // Collect unique reasons from all rooms on this floor
      const reasons = [];
      floor.rooms.forEach((room, index) => {
        const recommendedRoom = recommendedFloor.rooms[index];
        if (recommendedRoom) {
          const reason = recommendedRoom.getRecommendationReasoning();
          if (reason && !reasons.includes(reason)) {
            reasons.push(reason);
          }
        }
      });
      
      if (reasons.length > 0) {
        reasonCell.innerHTML = `<strong>No smart vent recommendations for this floor:</strong><br/>${reasons.join('<br/>')}`;
      } else {
        reasonCell.innerHTML = '<strong>No smart vent recommendations for this floor.</strong>';
      }
      reasonRow.appendChild(reasonCell);
      table.appendChild(reasonRow);
    }
  } else {
    // mobile version
    if (hasCurrentFloorRecommendations) {
      floor.rooms.forEach((room, index) => {
        const recommendedRoom = recommendedFloor.rooms[index];
        if (recommendedRoom.smartVentCandidate) {
          const row1 = document.createElement('tr');
          row1.innerHTML = `
            <td colspan="3" class="room-name">${room.getName()}</td>
            <td colspan="3"></td>
          `;
          table.appendChild(row1);

          // qnt and dropdown
          const row2 = document.createElement('tr');
          var html = `
            <td class="room-attribute-text">Qty. </td>
          `;
          html += `<td><select class="vent-count-dropdown">`;
          // <option value=""${room.vent_count === null ? ' selected': ''}>-</option>
          html += `<option value=""${room.vent_count === null ? ' selected': ''}>-</option>`;
          for(let i=0; i<6; i++) {
            html += `<option value="${i}"${room.vent_count === i ? ' selected': ''}>${i}</option>`;
          }
          html += `</select></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>`;
          row2.innerHTML = html;
          table.appendChild(row2);

          // sizes and dropdowns
          const row3 = document.createElement('tr');
          if (room.vent_count === null || room.vent_count === 0) {
            row3.style.display = 'none';
          }
          var html = `
            <td class="room-attribute-text">Sizes </td>
          `;
          for(let i=0; i<5; i++){
            html += `<td><select class="vent-size-dropdown">`;
            html += `<option value="">-</option>`;
            document.querySelectorAll('[data-product="vent"]').forEach(div => {
              let size = div.getAttribute('data-variant');
              let extraAttributes = ``;
              if (room.vents !== null) {
                if (room.vents.length >= i+1 ) {
                  extraAttributes += room.vents[i].size === size ? ' selected': ''
                }
              }
              html += `<option value="${size}"${extraAttributes}>${size}</option>`;
            });
            html += `</select></td>`;
          }
          row3.innerHTML = html;
          table.appendChild(row3);


          // Set the initial values based on the structure
          const ventCountDropdown = row2.querySelector('.vent-count-dropdown');

          // Show/hide vent size dropdowns based on the vent count
          const ventSizeDropdowns = row3.querySelectorAll('.vent-size-dropdown');
          ventSizeDropdowns.forEach((dropdown, i) => {
            dropdown.style.display = i < room.vents.length ? 'block' : 'none';
            if (room.vents[i]) {
              dropdown.value = room.vents[i].getSize();
            }
          });

          // Add event listener for vent count changes
          ventCountDropdown.addEventListener('change', (event) => {
            const count = parseInt(event.target.value, 10);
            structure.floors[floorIndex].rooms[index].vent_count = count;

            structure.floors[floorIndex].rooms[index].vents = Array.from({ length: count }, (_, i) => room.vents[i] || new models.SmartVent());
            ventSizeDropdowns.forEach((dropdown, i) => {
              dropdown.style.display = i < count ? 'block' : 'none';
            });
            
            row3.style.display = count > 0 ? 'revert' : 'none';

            // // Update getStartedRecommendation
            // const getStartedRoom = structure.getStartedRecommendation.floors[floorIndex].rooms[index];
            // getStartedRoom.vents = Array.from({ length: count }, (_, i) => getStartedRoom.vents[i] || new models.SmartVent());

            const recommendedRoom = structure.recommendation.floors[floorIndex].rooms[index];
            recommendedRoom.vent_count = count;
            recommendedRoom.vents = Array.from({ length: count }, (_, i) => recommendedRoom.vents[i] || new models.SmartVent());
            
            if(DEBUG) {
              console.log('ventCountDropdown changes... ');
              console.log(room);
            }
            saveStructureToLocalStorage();
          });

          // Add event listeners for vent size changes
          ventSizeDropdowns.forEach((dropdown, i) => {
            dropdown.addEventListener('change', (event) => {
              if (structure.floors[floorIndex].rooms[index].vents[i]) {
                structure.floors[floorIndex].rooms[index].vents[i].setSize(event.target.value);
              }

              // // Update getStartedRecommendation
              // const getStartedRoom = structure.getStartedRecommendation.floors[floorIndex].rooms[index];
              // if (getStartedRoom.vents[i]) {
              //   getStartedRoom.vents[i].setSize(event.target.value);
              // }
              
              const recommendedRoom = structure.recommendation.floors[floorIndex].rooms[index];
              if (recommendedRoom.vents[i]) {
                recommendedRoom.vents[i].setSize(event.target.value);
              }

              saveStructureToLocalStorage();
            });
          });
        }
      });
    } else {
      // No recommendations for current floor - show message with reasoning
      const reasonRow = document.createElement('tr');
      const reasonCell = document.createElement('td');
      reasonCell.colSpan = 6; // Span all columns in mobile view
      reasonCell.style.textAlign = 'center';
      reasonCell.style.padding = '20px';
      
      // Collect unique reasons from all rooms on this floor
      const reasons = [];
      floor.rooms.forEach((room, index) => {
        const recommendedRoom = recommendedFloor.rooms[index];
        if (recommendedRoom) {
          const reason = recommendedRoom.getRecommendationReasoning();
          if (reason && !reasons.includes(reason)) {
            reasons.push(reason);
          }
        }
      });
      
      if (reasons.length > 0) {
        reasonCell.innerHTML = `<strong>No smart vent recommendations for this floor:</strong><br/>${reasons.join('<br/>')}`;
      } else {
        reasonCell.innerHTML = '<strong>No smart vent recommendations for this floor.</strong>';
      }
      reasonRow.appendChild(reasonCell);
      table.appendChild(reasonRow);
    }
  }

  currentFloorDiv.appendChild(table);
  currentFloorContainer.appendChild(currentFloorDiv);

  // Generate content for the next floor if it exists
  if (floorIndex + 1 < structure.floors.length) {
    const nextFloor = structure.floors[floorIndex + 1];
    const nextRecommendedFloor = structure.recommendation.floors[floorIndex + 1];
    const nextFloorDiv = document.createElement('div');
    nextFloorDiv.classList.add('name-room-hvac');
    nextFloorDiv.innerHTML = `<h3>${nextFloor.getName()}</h3>`;
    const nextTable = document.createElement('table');
    nextTable.className = '_'; // bass.css requires at least some class be set to override
    
    // Check if any rooms on the next floor have smart vent recommendations
    const hasNextFloorRecommendations = nextFloor.rooms.some((room, index) => {
      const recommendedRoom = nextRecommendedFloor.rooms[index];
      return recommendedRoom && recommendedRoom.smartVentCandidate;
    });

    const nextHeaderRow = document.createElement('tr');
    nextHeaderRow.innerHTML = `
      <th>Room</th>
      <th>No.</th>
      <th class="divider"></th>
      <th>Vent 1</th>
      <th>Vent 2</th>
      <th>Vent 3</th>
      <th>Vent 4</th>
      <th>Vent 5</th>
    `;
    nextTable.appendChild(nextHeaderRow);

    if (hasNextFloorRecommendations) {
      nextFloor.rooms.forEach((room, index) => {
        const recommendedRoom = nextRecommendedFloor.rooms[index];
        if (recommendedRoom.smartVentCandidate) {
          const row = document.createElement('tr');

          let html = `
          <td>${room.getName()}</td>
          <td>
            <select class="vent-count-dropdown" disabled>
              <option value=""${room.vent_count === null ? ' selected': ''}>-</option>
              <option value="0"${room.vent_count === 0 ? ' selected': ''}>0</option>
              <option value="1"${room.vent_count === 1 ? ' selected': ''}>1</option>
              <option value="2"${room.vent_count === 2 ? ' selected': ''}>2</option>
              <option value="3"${room.vent_count === 3 ? ' selected': ''}>3</option>
              <option value="4"${room.vent_count === 4 ? ' selected': ''}>4</option>
              <option value="5"${room.vent_count === 5 ? ' selected': ''}>5</option>
            </select>
          </td>
          <td class="divider"></td>`;
          // loop 5 times
          for(let i=0; i<5; i++){
            html += `<td><select class="vent-size-dropdown" disabled>`;
            document.querySelectorAll('[data-product="vent"]').forEach(div => {
              let size = div.getAttribute('data-variant');
              let extraAttributes = ``;
              if (room.vents !== null) {
                if (room.vents.length >= i+1 ) {
                  extraAttributes += room.vents[i].size === size ? ' selected': ''
                }
              }
              html += `<option value="${size}"${extraAttributes}>${size}</option>`;
            });
            html += `</select></td>`;
          }
          row.innerHTML = html;
          nextTable.appendChild(row);

          // Set the initial values based on the structure
          const ventCountDropdown = row.querySelector('.vent-count-dropdown');

          // Show/hide vent size dropdowns based on the vent count
          const ventSizeDropdowns = row.querySelectorAll('.vent-size-dropdown');
          ventSizeDropdowns.forEach((dropdown, i) => {
            dropdown.style.display = i < room.vents.length ? 'block' : 'none';
            if (room.vents[i]) {
              dropdown.value = room.vents[i].getSize();
            }
          });

          // Add event listener for vent count changes
          ventCountDropdown.addEventListener('change', (event) => {
            const count = parseInt(event.target.value, 10);
            structure.floors[floorIndex + 1].rooms[index].vent_count = count;

            structure.floors[floorIndex + 1].rooms[index].vents = Array.from({ length: count }, (_, i) => room.vents[i] || new models.SmartVent());
            ventSizeDropdowns.forEach((dropdown, i) => {
              dropdown.style.display = i < count ? 'block' : 'none';
            });

            // // Update getStartedRecommendation
            // const getStartedRoom = structure.getStartedRecommendation.floors[floorIndex].rooms[index];
            // getStartedRoom.vents = Array.from({ length: count }, (_, i) => getStartedRoom.vents[i] || new models.SmartVent());

            const recommendedRoom = structure.recommendation.floors[floorIndex + 1].rooms[index];
            recommendedRoom.vent_count = count;
            recommendedRoom.vents = Array.from({ length: count }, (_, i) => recommendedRoom.vents[i] || new models.SmartVent());

            saveStructureToLocalStorage();
          });

          // Add event listeners for vent size changes
          ventSizeDropdowns.forEach((dropdown, i) => {
            dropdown.addEventListener('change', (event) => {
              if (structure.floors[floorIndex + 1].rooms[index].vents[i]) {
                structure.floors[floorIndex + 1].rooms[index].vents[i].setSize(event.target.value);
              }

              // // Update getStartedRecommendation
              // const getStartedRoom = structure.getStartedRecommendation.floors[floorIndex].rooms[index];
              // if (getStartedRoom.vents[i]) {
              //   getStartedRoom.vents[i].setSize(event.target.value);
              // }

              const recommendedRoom = structure.recommendation.floors[floorIndex + 1].rooms[index];
              if (recommendedRoom.vents[i]) {
                recommendedRoom.vents[i].setSize(event.target.value);
              }

              saveStructureToLocalStorage();
            });
          });
        }
      });
    } else {
      // No recommendations for next floor - show message with reasoning
      const reasonRow = document.createElement('tr');
      const reasonCell = document.createElement('td');
      reasonCell.colSpan = 8; // Span all columns
      reasonCell.style.textAlign = 'center';
      reasonCell.style.padding = '20px';
      
      // Collect unique reasons from all rooms on the next floor
      const reasons = [];
      nextFloor.rooms.forEach((room, index) => {
        const recommendedRoom = nextRecommendedFloor.rooms[index];
        if (recommendedRoom) {
          const reason = recommendedRoom.getRecommendationReasoning();
          if (reason && !reasons.includes(reason)) {
            reasons.push(reason);
          }
        }
      });
      
      if (reasons.length > 0) {
        reasonCell.innerHTML = `<strong>No smart vent recommendations for this floor:</strong><br/>${reasons.join('<br/>')}`;
      } else {
        reasonCell.innerHTML = '<strong>No smart vent recommendations for this floor.</strong>';
      }
      reasonRow.appendChild(reasonCell);
      nextTable.appendChild(reasonRow);
    }

    nextFloorDiv.appendChild(nextTable);
    nextFloorContainer.appendChild(nextFloorDiv);
  }
  updateImagePaths();
}

function showWarningPopup() {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  document.body.style.pointerEvents = 'auto';
  Swal.fire({
    html: `Ducted systems always have one or more thermostats - please ensure that you have identified at least one thermostat before proceeding.`,
    allowOutsideClick: false,
    showCloseButton: true,
  });
}

function closeWarningPopup() {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  removeOverlay();
  const popup = document.querySelector('.flair-solution-builder .warning-popup');
  if (popup) popup.remove();
}

function nextFloorOrStep() {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  const currentFloorContainer = document.getElementById('current-floor-container');
  const nextFloorContainer = document.getElementById('next-floor-container');

  if (currentFloorIndex < structure.floors.length - 1) {
    currentFloorContainer.classList.add('fade-out');
    nextFloorContainer.classList.add('slide-in-right');

    nextFloorContainer.addEventListener('animationend', () => {
      currentFloorContainer.classList.remove('fade-out');
      nextFloorContainer.classList.remove('slide-in-right');
      currentFloorIndex++;
      generateFloorContent(currentFloorIndex);
    }, { once: true });

    // Move the next-floor-container to the correct position before regenerating content
    nextFloorContainer.style.transform = `translateX(${currentFloorContainer.offsetWidth}px)`;
    requestAnimationFrame(() => {
      nextFloorContainer.style.transition = 'transform 0.5s';
      nextFloorContainer.style.transform = 'translateX(0)';
    });
  } else {
    // Check if any room has a thermostat
    const hasThermostat = structure.floors.some(floor => 
      floor.rooms.some(room => room.thermostats.length > 0)
    );

    if (!hasThermostat) {
      showWarningPopup();
    } else {
      nextStep(5); // Move to step 5 if there are no more floors
    }
  }
}

function prevFloorOrStep() {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  const currentFloorContainer = document.getElementById('current-floor-container');
  const nextFloorContainer = document.getElementById('next-floor-container');

  if (currentFloorIndex > 0) {
    currentFloorContainer.classList.add('slide-out-right');
    nextFloorContainer.classList.add('slide-in-left');
    nextFloorContainer.classList.add('fade-in');

    currentFloorContainer.addEventListener('animationend', () => {
      currentFloorContainer.classList.remove('slide-out-right');
      nextFloorContainer.classList.remove('slide-in-left');
      nextFloorContainer.classList.remove('fade-in');
      currentFloorIndex--;
      generateFloorContent(currentFloorIndex);
    }, { once: true });
  } else {
    prevStep(3); // Move to step 3 if we are at the first floor
  }
}

function nextFloorOrStepStep5() {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  const currentFloorContainer = document.getElementById('current-floor-container-step-5');
  const nextFloorContainer = document.getElementById('next-floor-container-step-5');
  var areNoErrors = true;

  // make sure class of when-heating-dropdown and when-cooling-dropdown doesn't have a '-' selected, but only for enabled ones
  document.querySelectorAll("[class*='when-'][class*='-dropdown']:not([disabled])").forEach(element => {
    if(element.value.includes('-')) {
      areNoErrors = false;
      Swal.fire({
        title: 'Error',
        text: 'Please make sure all rooms have a valid heating/cooling condition.',
        icon: 'error'
      });
      return;
    }
  });

  if (!areNoErrors) {
    return; // Exit the function early if there are errors
  }

  if (currentFloorIndex < structure.floors.length - 1) {
    currentFloorContainer.classList.add('fade-out');
    nextFloorContainer.classList.add('slide-in-right');

    nextFloorContainer.addEventListener('animationend', () => {
      currentFloorContainer.classList.remove('fade-out');
      nextFloorContainer.classList.remove('slide-in-right');
      currentFloorIndex++;
      generateFloorContentStep5(currentFloorIndex);
    }, { once: true });

    // Move the next-floor-container to the correct position before regenerating content
    nextFloorContainer.style.transform = `translateX(${currentFloorContainer.offsetWidth}px)`;
    requestAnimationFrame(() => {
      nextFloorContainer.style.transition = 'transform 0.5s';
      nextFloorContainer.style.transform = 'translateX(0)';
    });
  } else {
    nextStep(6); // Move to step 6 if there are no more floors
  }
}

function prevFloorOrStepStep5() {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  const currentFloorContainer = document.getElementById('current-floor-container-step-5');
  const nextFloorContainer = document.getElementById('next-floor-container-step-5');

  if (currentFloorIndex > 0) {
    currentFloorContainer.classList.add('slide-out-right');
    nextFloorContainer.classList.add('slide-in-left');
    nextFloorContainer.classList.add('fade-in');

    currentFloorContainer.addEventListener('animationend', () => {
      currentFloorContainer.classList.remove('slide-out-right');
      nextFloorContainer.classList.remove('slide-in-left');
      nextFloorContainer.classList.remove('fade-in');
      currentFloorIndex--;
      generateFloorContentStep5(currentFloorIndex);
    }, { once: true });
  } else {
    prevStep(4); // Move to step 4 if we are at the first floor
  }
}

function nextFloorOrStepStep9() {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  const currentFloorContainer = document.getElementById('current-floor-container-step-9');
  let hasEmptyVentCountDropdown = [...document.querySelectorAll('.vent-count-dropdown')].some(dropdown => { return dropdown.value === "" && window.getComputedStyle(dropdown).display !== 'none' && !dropdown.disabled;});
  let hasEmptyVentSizeDropdown = [...document.querySelectorAll('.vent-size-dropdown')].some(dropdown => { return dropdown.value === "" && window.getComputedStyle(dropdown).display !== 'none' && !dropdown.disabled;});
  if(DEBUG) {
    console.log([...document.querySelectorAll('.vent-size-dropdown')]);
  }

  // if (hasEmptyVentCountDropdown || hasEmptyVentSizeDropdown) {
  //   prevFloorOrStepStep9();
  // }

  if (hasEmptyVentCountDropdown || hasEmptyVentSizeDropdown) {  
    if(hasEmptyVentCountDropdown) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        html: 'Please make sure to enter a number of supply vents for all listed rooms. If there are no supply vents in the room, enter 0.',
      });
    }

    if(!hasEmptyVentCountDropdown && hasEmptyVentSizeDropdown) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        html: 'Please make sure all vents have a size selected.',
      });
    }
  } else if ((currentFloorIndex < structure.recommendation.floors.length - 1)) {
    currentFloorContainer.classList.add('fade-out');

    currentFloorContainer.addEventListener('animationend', () => {
      currentFloorContainer.classList.remove('fade-out');
      currentFloorIndex++;
      generateFloorContentStep9(currentFloorIndex);
    }, { once: true });
  } else {
    nextStep("9B"); // Move to step 9B if there are no more floors
  }
}

function prevFloorOrStepStep9() {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  const currentFloorContainer = document.getElementById('current-floor-container-step-9');

  if (currentFloorIndex > 0) {
    currentFloorContainer.classList.add('fade-out');

    currentFloorContainer.addEventListener('animationend', () => {
      currentFloorContainer.classList.remove('fade-out');
      currentFloorIndex--;
      generateFloorContentStep9(currentFloorIndex);
    }, { once: true });
  } else {
    prevStep(8); // Move to step 8 if we are at the first floor
  }
}

function convertStepToText(step) {
  if (step === 1) {
    return 'landing'
  }

  if (step === 2) {
    return 'system type select'
  }

  if (step === 3) {
    return 'floor and room count'
  }

  if (step === 4) {
    return 'room name and tstat location'
  }

  if (step === 5) {
    return 'room conditions'
  }

  if (step === 6) {
    return 'ducted thank you and email recommendation'
  }

  if (step === 7) {
    return 'analysis'
  }

  if (step === 8) {
    return 'how to measure vents'
  }

  if (step === 9) {
    return 'room vent count and sizes'
  }

  if (step === "9B") {
    return 'puck generation selection'
  }

  if (step === 10) {
    // used by both ducted and ductless
    return 'recommended solution'
  }

  if (step === 11) {
    return 'ductless count'
  }

  if (step === 12) {
    return 'minisplits but need more info for other units'
  }

  if (step === 13) {
    // continuation of step 12
    return 'minisplits but ask to clarify the remote types'
  }

  if (step === 14) {
    return 'ductless thank you and email recommendation'
  }

  
  if (step === 99) {
    return 'blank page for tooltips'
  }
}

function convertStepToAnalytics(laststep=0, nextstep=0) {
  
  gtag('event', 'solutionBuilder.step', {
    'laststep': laststep,
    'laststeptext': convertStepToText(laststep),
    'nextstep': nextstep,
    'nextsteptext': convertStepToText(nextstep)
  });
}

function nextStep(step, arg="", puckGeneration=null) {
  if (window.innerWidth < 840) {
    _hideLiveChatButton();
  }

  if (step < 90) {
    lastNon99Step = step;
  }

  convertStepToAnalytics(currentStep, step);
  if(DEBUG) {
    console.log(new Error().stack);
    console.log(structure); // TODO: REMOVE DEBUG
    console.log(`currentStep: ${currentStep}; nextStep: ${step}; arg: ${arg}; puckGeneration: ${puckGeneration}`);
  }
  
  // Save puckGeneration if provided
  if (puckGeneration !== null) {
    structure.puckGeneration = puckGeneration;
    saveStructureToLocalStorage();
  }

  const container = document.querySelector('.flair-solution-builder .container');
  const currentStepElement = container.querySelector(`#step-${currentStep}`);
  const nextStepElement = container.querySelector(`#step-${step}`);
  const progressContainer = container.querySelector('.progress-container');
  const buttonContainerNavigation = container.querySelector('.button-container-navigation');

  nextStepElement.classList.add('off-screen-right');
  nextStepElement.style.display = 'flex'; // Ensure the next step is visible
  currentStepElement.classList.add('slide-out-left');
  nextStepElement.classList.add('slide-in-right');
  progressContainer.classList.add('slide-out-left');
  buttonContainerNavigation.classList.add('slide-out-left');

  currentStepElement.addEventListener('animationend', () => {
    currentStepElement.classList.remove('active', 'slide-out-left');
    currentStepElement.style.display = 'none'; // Hide the current step
    nextStepElement.classList.add('active');
    nextStepElement.classList.remove('slide-in-right', 'off-screen-right');
    progressContainer.classList.remove('slide-out-left');
    buttonContainerNavigation.classList.remove('slide-out-left');

    // find all id='house-image-complete' and update their img src
    document.querySelectorAll('#house-image-complete').forEach(img => {
      img.src = SB_IMG_URLS[`Solution-Builder-${structure.floors.length}-Floors-Ticks.min.png`];
    });

    // add Ducted hvacSystem if it doesn't already exist
    if (step === 3) {
      populateStep3();
    }

    if (step === 11) {
      // remove non-ductless thermostats
      structure.hvacSystems.filter(system => system.systemType === 'forced-air').forEach(system => structure.removeHVACSystem(system));
      populateStep11();
    }

    // Generate floor content for step 4
    if (step === 4) {
      if (structure.floors.length == 0) {
        // show popup alert saying they need to select at least one floor and after hitting ok go to nextStep(3)
        document.body.style.pointerEvents = 'auto';
        Swal.fire({
          icon: 'warning',
          title: 'Oops...',
          text: 'You need to select at least one floor!',
        }).then(() => {
          prevStep(3); // Go to the previous step after clicking OK
        });
      }
      // make sure all floors have at least one room in them
      var valid_number_rooms = true;
      for (let i = 0; i < structure.floors.length; i++) {
        if (structure.floors[i].rooms.length == 0) {
          valid_number_rooms = false;
        }
      }
      if (!valid_number_rooms) {
        document.body.style.pointerEvents = 'auto';
        Swal.fire({
          icon: 'warning',
          title: 'Oops...',
          text: 'All floors need at least one room!',
        }).then(() => {
          prevStep(3); // Go to the previous step after clicking OK
        });
      }

      currentFloorIndex = 0; // Reset to the first floor
      generateFloorContent(currentFloorIndex);
    }

    // Generate floor content for step 5
    if (step === 5) {
      currentFloorIndex = 0; // Reset to the first floor
      generateFloorContentStep5(currentFloorIndex);
    }

    // Run makeRecommendation and makeGetStartedRecommendation when leaving step 5 or 14
    if (currentStep === 6 || currentStep === 14) {
      saveStructureToLocalStorage();
      structure.makeRecommendation();
      structure.makeGetStartedRecommendation();
    } 

    // null the non-minisplits so they can be updated 
    if (step === 13) {
      structure.hvacSystems.filter(system => system.systemType !== "ductless-minisplits").forEach(hvac => hvac.supportsRemote = null);
    }

    // Generate analysis table for step 7
    if (step === 7) {
      generateAnalysisTable();
    }

    // Generate floor content for step 9
    if (step === 9) {
      currentFloorIndex = 0; // Reset to the first floor
      generateFloorContentStep9(currentFloorIndex);
      setHouseImageStep9();
    }
    
    // Handle step 9B (Puck Generation selection)
    if (step === "9B") {
      // Puck generation is set in the onclick handler, so we don't need to do anything here
      // HOTFIX: If they don't have any Puck recommendations, skip this section and go to the next
      // Note: Leave non-skip for analytics
      // if (!structure.recommendation.floors.some(floor => floor.rooms.some(room => room.puckCandidate))) {
      //   nextStep(10);
      // }
    }

    // Generate recommendation content for step 10
    if (step === 10) {
      generateRecommendationContent();
    }

    // Set house image for step 6
    if (step === 6) {
      setHouseImage();
    }

    // if step is 14 (where previous step was 13), update their supported hvacSystem stuff
    if (step === 14) {
      structure.hvacSystems.forEach(system => {
        // if not already set to false, then they said it was supported
        if (system.supportsRemote === null) {
          system.supportsRemote = true;
        }
      });
    }

    // if step is 12, and step 10 had only minisplits selected, skip to step 14
    // TODO: idk something about filtering out steps
    if (step === 99) {
      console.log(`Current Step: ${currentStep}; Step: ${step}; lastNon99Step: ${lastNon99Step}`);
      if (lastNon99Step > 8 && lastNon99Step < 99 && arg === "") {
        // cleanup any existing non-ductless hvac systems
        structure.hvacSystems.filter(system => system.systemType === 'forced-air').forEach(system => structure.removeHVACSystem(system));

        // if there are no hvacSystems at all, do Swal.fire() alert and go back to previous step
        if (structure.hvacSystems.length === 0) {
          document.body.style.pointerEvents = 'auto';
          Swal.fire({
            icon: 'warning',
            title: 'Oops...',
            text: 'You need to select at least one Ductless unit!',
          }).then(() => {
            prevStep(11); // Go to the previous step after clicking OK
          });
        } else {
          // check if their structure.hvacSystems are all of system.systemType === 'ductless-minisplit'
          if (structure.hvacSystems.every(system => system.systemType === 'ductless-minisplit')) {
            // if they are, ...
            nextStep(14);
          } else {
            // if they have some minisplits
            if (structure.hvacSystems.filter(system => system.systemType === 'ductless-minisplit').length > 0) {
              // let them know we need some information about their other remotes
              nextStep(12);
            } else {
              // just ask about their remotes
              nextStep(13);
            }
          }
        }
      } else {
        // bypass option to either continue with flow
        if (arg === "ducted") {
          structure.setSystemType("zoning-air-balancing");
          nextStep(3);
        } else if (arg === "ductless") {
          structure.setSystemType("ductless-controls");
          nextStep(2);
        } else if (arg === "Wire-Free" || arg === "Wired") {
          // Save puckDesire for step-2
          structure.setPuckDesiredConfiguration(arg);
          saveStructureToLocalStorage();
          // Continue to step-3 for ductless
          nextStep(11);
        } else if (arg === "reset") {
          structure.unsetSystemType();
          nextStep(1);
        } else {
          if (structure.getSystemType() === "ductless-controls") {
            nextStep(11);
          }
        }
      }
    }

    // // Update the open wizard button text
    // updateOpenWizardButton();
  }, { once: true });

  currentStep = step;

  // Reset to the first floor for steps with multiple floors
  if (floorData[currentStep] && step !== 10) {
    floorData[currentStep] = 1;
    showFloor(currentStep, floorData[currentStep]);
  }
  saveStructureToLocalStorage();
}

function generateRecommendationContent() {
  if(DEBUG) {
    console.log(new Error().stack);
    console.log('models object:', models);
    console.log('models.Puck2:', models.Puck2);
  }
  const imgSrcPLUSicon = document.querySelector('#image-url-container img[data-src="assets/Solution-Builder-PLUS-icon.png"]').getAttribute('src');
  const imgSrcMINUSicon = document.querySelector('#image-url-container img[data-src="assets/Solution-Builder-MINUS-icon.png"]').getAttribute('src');
  const recommendationBoxs = document.querySelectorAll('.recommendation-box');
  recommendationBoxs.forEach(recommendationBox => {
    recommendationBox.innerHTML = ''; // Clear existing content

    // Update the title of the solution
    const titleElement = document.querySelector('#step-10 .title-container h2');
    if (titleElement) {
      if (structure.getSystemType() === "ductless-controls") {
        titleElement.innerHTML = "Here's your <span class=\"title-bold\">Ductless Controls</span> solution!";
      } else {
        titleElement.innerHTML = `Here's your <span class=\"title-bold\">Flair</span> solution!`;
      }
    }

    // Conditional display and description for Flair Bridge
    const bridgeVariantID = new models.Bridge().variant_id;
    let showBridge = true;
    let bridgeDescription = 'Every Flair Solution requires a Bridge to serve as the central networking device';
    let bridgeQuantity = 1;

    if (structure.getSystemType() === "zoning-air-balancing") {
      // Ducted: Always display Flair Bridge with quantity 1
      showBridge = true;
      bridgeDescription = 'Every Flair Solution requires a Bridge to serve as the central networking device';
    } else if (structure.getSystemType() === "ductless-controls" && structure.puckDesire === "Wire-Free") {
      // Ductless Wire-Free: Display Flair Bridge with quantity 1
      showBridge = true;
      bridgeDescription = "You selected wire-free configuration. This requires a Bridge networking device. If you prefer wired control, a Bridge isn't necessary. One Flair Bridge supports up to 40 devices and 2,500 sq. ft.; add more Bridges for larger spaces.";
    } else if (structure.getSystemType() === "ductless-controls" && structure.puckDesire === "Wired") {
      // Ductless Wired: Do NOT initially display Flair Bridge in the main recommendation list
      showBridge = false;
    }

    if (showBridge) {
      const newRow = createRecommendationRow(
        document.querySelector('#image-url-container img[data-src="assets/Solution-Builder-Bridge.min.png"]').getAttribute('src'),
        'Flair Bridge',
        'Networking Device',
        'bridge',
        bridgeVariantID,
        bridgeQuantity,
        parseInt(document.querySelector(`#variant-${bridgeVariantID}`).getAttribute('data-price'))/100,
        bridgeDescription
      );
      recommendationBox.appendChild(newRow);
      // -- add bridge to cart model
      const cartitem_bridge = new models.CartItem(bridgeVariantID, bridgeQuantity);
      structure.cart_data.addItem(cartitem_bridge);
    }

    // Calculate Puck quantity
    let puckVariantID;
    let puckGenerationInt = 2;
    if (structure.puckGeneration === 2.0) {
      if(DEBUG) {
        console.log('About to instantiate Puck2');
        console.log('models.Puck2:', models.Puck2);
      }
      try {
        puckVariantID = new models.Puck2().variant_id;
        puckGenerationInt = 2;
      } catch (error) {
        console.error('Error instantiating Puck2:', error);
        // Fallback to Puck if Puck2 fails
        puckVariantID = new models.Puck().variant_id;
        puckGenerationInt = 1;
      }
    } else {
      puckVariantID = new models.Puck().variant_id;
      puckGenerationInt = 1;
    }
    
    let puckQuantity = 0;
    structure.recommendation.floors.forEach(floor => {
      floor.rooms.forEach(room => {
        if (room.puckCandidate) {
          puckQuantity++;
        }
      });
    });

    // make sure there is at least one puck per thermostat hvacSystem
    // FIX MSS-170
    // if (structure.hvacSystems.filter(system => system.systemType === "forced-air").length > puckQuantity) {
    //  puckQuantity = structure.hvacSystems.length;
    // }

    // ductless doesn't have floors, so we need to adjust the quantity for ductless systems that have supported remotes
    if (structure.hvacSystems.filter(system => system.systemType !== "forced-air" && system.supportsRemote).length > 0) {
      puckQuantity = structure.hvacSystems.filter(system => system.supportsRemote).length;
    }

    if (puckQuantity > 0) {
      // Add Flair Puck
      var puckDescription = 'Each room with Flair Smart Vents that does not already have a supported smart thermostat or sensor requires a Puck to manage temperature in the room.';
      if (structure.hvacSystems.filter(system => system.systemType !== "forced-air").length > 0) {
        puckDescription = 'A Flair Puck is required to control the operation of each Ductless Unit.';
        // Add puck generation information if available
      }

      const puckVariantElement = document.querySelector(`#variant-${puckVariantID}`);
      let puckPrice = 0;

      if (puckVariantElement) {
        puckPrice = parseInt(puckVariantElement.getAttribute('data-price'))/100;
      } else if (puckVariantID === 'puck2-placeholder') {
        // Fallback price for Puck2 when not available in Shopify
        puckPrice = 124; // $124 USD as specified
      }

      const puckImageElement = document.querySelector(`#image-url-container img[data-src="assets/Solution-Builder-Step-10-Puck-${puckGenerationInt}.png"]`);
      const puckImageSrc = puckImageElement ? puckImageElement.getAttribute('src') : `assets/Solution-Builder-Step-10-Puck-${puckGenerationInt}.png`;

      const newRow = createRecommendationRow(
        puckImageSrc,
        puckGenerationInt === 2 ? 'Flair Puck 2.0' : 'Flair Puck 1.0',
        structure.getSystemType() === "ductless-controls" ? "Ductless Thermostat" : "Ducted Thermostat",
        'puck',
        puckVariantID,
        puckQuantity,
        puckPrice,
        puckDescription
      );
      recommendationBox.appendChild(newRow);
      // -- add puck to cart model
      const cartitem_puck = new models.CartItem(puckVariantID, puckQuantity);
      structure.cart_data.addItem(cartitem_puck);
    }

    // Control visibility of the new #add-bridge-section
    const mediaQuery = window.matchMedia('(max-width: 800px)');
    const addBridgeSection = document.getElementById('add-bridge-section');
    if (addBridgeSection) {
      if (structure.getSystemType() === "ductless-controls" && structure.puckDesire === "Wired") {
        // Make the #add-bridge-section visible
        addBridgeSection.classList.remove('hidden');
        addBridgeSection.classList.add('visible');
        
        // Adjust recommendation box height based on screen size
        const adjustHeight = () => {
          if (mediaQuery.matches) {
            // Mobile: 280px
            recommendationBox.style.maxHeight = 'calc(350px - 70px)';
          } else {
            // Non-mobile: 182px
            recommendationBox.style.maxHeight = 'calc(350px - 182px)';
          }
        };

        // Initial adjustment
        adjustHeight();

        // Listen for changes in screen size
        mediaQuery.addListener(adjustHeight);

        // Create and inject the new layout for the add-bridge section
        const bridgeImgSrc = document.querySelector('#image-url-container img[data-src="assets/Solution-Builder-Bridge.min.png"]').getAttribute('src');
        addBridgeSection.innerHTML = `
          <div class="recommendation-row">
            <div class="add-bridge-top-row">
              <p class="product-description">If you'd like your Pucks to be wire-free, you'll need a Bridge networking device. One Flair Bridge supports up to 40 devices and 2,500 sq. ft.; add more Bridges for larger spaces.
              </p>
            </div>
            <div class="add-bridge-bottom-row">
              <div class="add-bridge-product-info">
                <div class="product-image">
                  <img src="${bridgeImgSrc}" alt="Flair Bridge">
                </div>
                <div class="product-text">
                  <div class="product-title">Flair Bridge</div>
                  <div class="product-subtitle">Networking Device</div>
                </div>
              </div>
              <div class="add-bridge-button-container hide-on-mobile">
                <button class="recommendation-button add-bridge-button">ADD A BRIDGE</button>
              </div>
            </div>
              <div class="add-bridge-button-container hide-on-desktop" style="text-align: center; width: 100% !important; margin-top: 0.5em;">
                <button class="recommendation-button add-bridge-button" style="width: 100% !important; margin: 10px 0;">ADD A BRIDGE</button>
              </div>
          </div>
        `;

        // Attach click event listener to ALL elements with the class 'add-bridge-button'
        const addBridgeButtons = document.querySelectorAll('.add-bridge-button'); // Using class instead of ID
        addBridgeButtons.forEach(button => {
          button.addEventListener('click', function() {
            // Add a single Flair Bridge to the cart
            const bridgeVariantID = new models.Bridge().variant_id;
            const cartitem_bridge = new models.CartItem(bridgeVariantID, 1);
            structure.cart_data.addItem(cartitem_bridge);

            // Create and add the bridge row to the recommendation display
            const newRow = createRecommendationRow(
              document.querySelector('#image-url-container img[data-src="assets/Solution-Builder-Bridge.min.png"]').getAttribute('src'),
              'Flair Bridge',
              'Networking Device',
              'bridge',
              bridgeVariantID,
              1,
              parseInt(document.querySelector(`#variant-${bridgeVariantID}`).getAttribute('data-price'))/100,
              "You manually added a Bridge. One Flair Bridge supports up to 40 devices and 2,500 sq. ft.; add more Bridges for larger spaces."
            );

            // Insert the bridge row into the main recommendation list
            recommendationBox.appendChild(newRow);

            // Hide the #add-bridge-section after adding the bridge
            addBridgeSection.classList.remove('visible');
            addBridgeSection.classList.add('hidden');
            
            // Restore recommendation box height when add-bridge-section is hidden
            recommendationBox.style.maxHeight = '350px';
          });
        });
      } else {
        // Hide the #add-bridge-section for all other system types or puck desires
        addBridgeSection.classList.remove('visible');
        addBridgeSection.classList.add('hidden');
        
        // Restore recommendation box height when add-bridge-section is hidden
        recommendationBox.style.maxHeight = '350px';
      }
    }

    // Calculate Smart Vent quantities
    const dataType = 'smart-vent';
    // imgsrc is the src from the img data-src matching 'Solution-Builder-Vent-Family.min.png'
    const imgSrc = document.querySelector('#image-url-container img[data-src="assets/Solution-Builder-Vent-Family.min.png"]').getAttribute('src');
    const productName = 'Flair Smart Vent';
    const ventSizes = {};
    structure.recommendation.floors.forEach(floor => {
      floor.rooms.forEach(room => {
        if (room.smartVentCandidate) {
          room.vents.forEach(vent => {
            const size = vent.getSize();
            if (!ventSizes[size]) {
              ventSizes[size] = 0;
            }
            ventSizes[size]++;
          });
        }
      });
    });

    if (Object.keys(ventSizes).length > 0) {
      const ventRowHeader = document.createElement('div');
      ventRowHeader.classList.add('recommendation-row');
      ventRowHeader.innerHTML = `
          <div class="product-image">
            <img src="${imgSrc}">
          </div>
          <div class="product-info">
            <div class="product-info-row">
              <div class="product-info-cell">
                <div class="product-title">${productName}</div>
              </div>
            </div>
          </div>`;
      recommendationBox.appendChild(ventRowHeader);

      const ventRow = document.createElement('div');
      ventRow.classList.add('recommendation-row');
      var ventHTML = ``;
      // Add Flair Smart Vents
      Object.keys(ventSizes).forEach(size => {
        var variantId = new models.SmartVent(size).variant_id;
        const quantity = ventSizes[size];
        var basePrice = -1;
        if (document.querySelector(`div [data-variant="${size}"]`) !== null) {
          // get data-variant where value is equal to size: <div id="variant-42942454986" data-product="" data-variant="4x10" data-id="42942454986" data-price="9900" data-compare-at-price=""></div>
          if(DEBUG) {
            console.log(document.querySelector(`div [data-variant="${size}"]`).getAttribute('data-price'));
          }
          basePrice = parseInt(document.querySelector(`div [data-variant="${size}"]`).getAttribute('data-price'))/100;
          variantId = parseInt(document.querySelector(`div [data-variant="${size}"]`).getAttribute('data-id'));
        } else {
          console.error('missing size selection...');
        }

        ventHTML += `
            <div class="product-info-row">
              <div class="product-info-cell" style="width: 17.5em; flex: unset; text-align: right; padding-right: 2em;">
                <div class="product-size">${size}</div>
              </div>
              
              <div class="product-info-cell" style="flex: unset; color: white;">
                <div class="variant-quantity">
                  <img src="${imgSrcMINUSicon}" class="quantity-button" data-type="${dataType}" data-id="${variantId}" onclick="adjustQuantity(this, -1)" />
                  <span class="quantity-count" style="color: white;">${quantity}</span>
                  <img src="${imgSrcPLUSicon}" class="quantity-button" data-type="${dataType}" data-id="${variantId}" onclick="adjustQuantity(this, 1)" />
                </div>
              </div>
              
              <div class="product-info-cell" style="flex: unset; text-align: right; width: 6.25em; color: white;">
                <div class="variant-subtotal" style="color: white;" data-price-per-unit="${basePrice}">$${(quantity * basePrice).toFixed(2)}</div>
              </div>
            </div>
            `;

        const cartitem_vent = new models.CartItem(variantId, quantity);
        structure.cart_data.addItem(cartitem_vent);
      });
      
      ventRow.innerHTML = `
          <div class="product-info product-detailed-description" style="width: 100%;">
            ${ventHTML}
          </div>`;
      recommendationBox.appendChild(ventRow);

    }
  });

  updateImagePaths();
  
  // Add scroll detection for recommendation box
  setupScrollForMoreOverlay();
}

function setupScrollForMoreOverlay() {
  // Get all recommendation boxes
  const recommendationBoxes = document.querySelectorAll('.recommendation-box');

  recommendationBoxes.forEach(box => {
    // Create overlay element
    const overlay = document.createElement('div');
    overlay.className = 'scroll-for-more-overlay';

    const text = document.createElement('div');
    text.className = 'scroll-for-more-text';
    text.textContent = 'Scroll for more';
    overlay.appendChild(text);

    // Add overlay to the recommendation box
    box.style.position = 'relative';
    box.appendChild(overlay);

    // Check scroll position and content scrollability
    function checkScrollable() {
      const isScrollable = box.scrollHeight > box.clientHeight;
      const isAtTop = box.scrollTop === 0;
      const isAtBottom = box.scrollTop + box.clientHeight >= box.scrollHeight - 5;

      // Show overlay only when content is scrollable AND at the top
      if (isScrollable && isAtTop) {
        overlay.classList.remove('hidden');
      } else {
        overlay.classList.add('hidden');
      }
    }

    // Add scroll event listener to hide overlay when user starts scrolling
    let scrollTimeout;
    box.addEventListener('scroll', function() {
      // Clear existing timeout
      clearTimeout(scrollTimeout);

      // If user is scrolling (not at top), hide overlay immediately
      if (box.scrollTop > 0) {
        overlay.classList.add('hidden');
      }

      // Set timeout to check scroll position after scrolling stops
      scrollTimeout = setTimeout(function() {
        checkScrollable();
      }, 150); // Wait 150ms after scrolling stops before checking position
    });

    // Initial check
    setTimeout(checkScrollable, 100);

    // Add scroll listener
    box.addEventListener('scroll', checkScrollable);

    // Add resize listener to handle content changes
    const resizeObserver = new ResizeObserver(checkScrollable);
    resizeObserver.observe(box);
  });
}

function createRecommendationRow(imgSrc, productName, productSubTitle, dataType, variantId, quantity, basePrice, productDescription) {
  if(DEBUG) {
    console.log(new Error().stack);
    console.log(window.SB_IMG_URLS);
    console.log(imgSrc);
  }
  const imgSrcPLUSicon = document.querySelector('#image-url-container img[data-src="assets/Solution-Builder-PLUS-icon.png"]').getAttribute('src');
  const imgSrcMINUSicon = document.querySelector('#image-url-container img[data-src="assets/Solution-Builder-MINUS-icon.png"]').getAttribute('src');
  const newRow = document.createElement('div');
  newRow.classList.add('recommendation-row');
  const size = '';

  newRow.innerHTML = `
    <div class="product-image">
      <img src="${imgSrc}">
    </div>
    <div class="product-info">
      <div class="product-info-row hide-on-desktop">
        <div class="product-info-cell">
          <div class="product-title">${productName}</div>
        </div>
      </div>
      <div class="product-info-row">
        <div class="product-info-cell hide-on-mobile">
          <div class="product-title">${productName}</div>
        </div>

        <div class="product-info-cell hide-on-mobile">
              <div class="product-size">${size}</div>
        </div>
        
        <div class="product-info-cell">
          <div class="variant-quantity">
            <img src="${imgSrcMINUSicon}" class="quantity-button" data-type="${dataType}" data-id="${variantId}" onclick="adjustQuantity(this, -1)" />
            <span class="quantity-count">${quantity}</span>
            <img src="${imgSrcPLUSicon}" class="quantity-button" data-type="${dataType}" data-id="${variantId}" onclick="adjustQuantity(this, 1)" />
          </div>
        </div>
        
        <div class="product-info-cell">
          <div class="variant-subtotal" data-price-per-unit="${basePrice}">$${(quantity * basePrice).toFixed(2)}</div>
        </div>
      </div>
      <div class="product-info-row">
        <div class="product-subtitle">${productSubTitle}</div>
      </div>
    </div>
  `;

  // Create a separate row for the detailed description if productDescription is provided
  if (productDescription) {
    const detailedDescriptionRow = document.createElement('div');
    detailedDescriptionRow.classList.add('recommendation-row', 'product-detailed-description');
    detailedDescriptionRow.innerHTML = `
      <div class="product-info">
        <div class="product-info-row">
          <div class="product-description">${productDescription}</div>
        </div>
      </div>
    `;
    
    // Create a container to hold both rows
    const container = document.createElement('div');
    container.style = "margin-bottom: 15px;"
    container.appendChild(newRow);
    container.appendChild(detailedDescriptionRow);
    
    return container;
  }

  return newRow;
}

function adjustQuantity(button, change) {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  const quantityCount = button.parentElement.querySelector('.quantity-count');
  let quantity = parseInt(quantityCount.textContent, 10);
  quantity = Math.max(0, quantity + change); // Ensure quantity is not negative
  quantityCount.textContent = quantity;

  // TODO: redo this sometime soon
  // -- find item data-id from this 'button' as the event
  // console.log(button);
  var variantID = parseInt(button.getAttribute('data-id'));
  // Convert variantID to a number (handle string or integer)
  const variantNumber = Number(variantID);
  // Find the index by converting item.id to a number
  const itemIndex = structure.cart_data.items.findIndex(item => {
    const itemNumber = Number(item.id);
    return !isNaN(itemNumber) && itemNumber === variantNumber;
  });
  if (itemIndex !== -1) {
    structure.cart_data.items[itemIndex].quantity = quantity;
  }

  if(DEBUG) {
    console.log(button.parentElement);
    console.log(button.parentElement.parentElement);
    console.log(button.parentElement.parentElement.parentElement);
  }

  const subtotalElement = button.parentElement.parentElement.parentElement.querySelector('.variant-subtotal');
  const pricePerUnit = parseFloat(subtotalElement.getAttribute('data-price-per-unit'));
  const subtotal = (quantity * pricePerUnit).toFixed(2);
  subtotalElement.textContent = `$${subtotal}`;
  
  saveStructureToLocalStorage();
}

function prevStep(step, arg="", puckGeneration=null) {
  /* to fix a bug with the cart and having Puck2 being a placeholder, we will flush the cart_data everytime this is called */
  structure.clearCart();
  
  if (window.innerWidth < 840) {
    _hideLiveChatButton();
  }

  if (step === -1) {
    step = lastNon99Step;
  } 

  if (step < 90) {
    lastNon99Step = step;
  }
  
  convertStepToAnalytics(currentStep, step);
  if(DEBUG) {
    console.log(new Error().stack);
  }
  
  // Save puckGeneration if provided
  if (puckGeneration !== null) {
    structure.puckGeneration = puckGeneration;
    saveStructureToLocalStorage();
  }
  if (structure.hvacSystems.filter(system => system.systemType !== 'forced-air').length > 0) {
    if (currentStep == 10) {
      step = 11;
    }
  }

  if(DEBUG) {
    console.log(`currentStep: ${currentStep}`);
  }

  const container = document.querySelector('.flair-solution-builder');
  const currentStepElement = container.querySelector(`#step-${currentStep}`);
  const prevStepElement = container.querySelector(`#step-${step}`);
  const progressContainer = container.querySelector('.progress-container');
  const buttonContainerNavigation = container.querySelector('.button-container-navigation');

  prevStepElement.classList.add('off-screen-left');
  prevStepElement.style.display = 'flex'; // Ensure the previous step is visible
  currentStepElement.classList.add('slide-out-right');
  prevStepElement.classList.add('slide-in-left');
  progressContainer.classList.add('slide-out-right');
  buttonContainerNavigation.classList.add('slide-out-right');

  currentStepElement.addEventListener('animationend', () => {
    currentStepElement.classList.remove('active', 'slide-out-right');
    currentStepElement.style.display = 'none'; // Hide the current step
    prevStepElement.classList.add('active');
    prevStepElement.classList.remove('slide-in-left', 'off-screen-left', 'off-screen-right');
    progressContainer.classList.remove('slide-out-right');
    buttonContainerNavigation.classList.remove('slide-out-right');
  }, { once: true });

  currentStep = step;


  if (step === 3) {
    populateStep3();
  }

  if (step === 4) {
    currentFloorIndex = structure.floors.length - 1; // Reset to the last floor
    generateFloorContent(currentFloorIndex);
  }

  if (step === 5) {
    currentFloorIndex = structure.floors.length - 1;
    generateFloorContentStep5(currentFloorIndex);
  }
  
  if (step === 7) {
    generateAnalysisTable();
  }

  if (step === 9) {
    currentFloorIndex = structure.floors.length - 1; // Reset to the last floor
    generateFloorContentStep9(currentFloorIndex);
    setHouseImageStep9();
  }

  if (step === 11) {
    populateStep11();
  }

  // Reset to the last floor for steps with multiple floors
  if (floorData[currentStep]) {
    floorData[currentStep] = maxFloors;
    showFloor(currentStep, floorData[currentStep]);
  }


  if (step === 99) {
    console.log(`Current Step: ${currentStep}; Step: ${step}; lastNon99Step: ${lastNon99Step}`);
    if (lastNon99Step > 8 && lastNon99Step < 99 && arg === "") {
      // cleanup any existing non-ductless hvac systems
      structure.hvacSystems.filter(system => system.systemType === 'forced-air').forEach(system => structure.removeHVACSystem(system));

      // if there are no hvacSystems at all, do Swal.fire() alert and go back to previous step
      if (structure.hvacSystems.length === 0) {
        document.body.style.pointerEvents = 'auto';
        Swal.fire({
          icon: 'warning',
          title: 'Oops...',
          text: 'You need to select at least one Ductless unit!',
        }).then(() => {
          prevStep(11); // Go to the previous step after clicking OK
        });
      } else {
        // check if their structure.hvacSystems are all of system.systemType === 'ductless-minisplit'
        if (structure.hvacSystems.every(system => system.systemType === 'ductless-minisplit')) {
          // if they are, ...
          prevStep(14);
        } else {
          // if they have some minisplits
          if (structure.hvacSystems.filter(system => system.systemType === 'ductless-minisplit').length > 0) {
            // let them know we need some information about their other remotes
            prevStep(12);
          } else {
            // just ask about their remotes
            prevStep(13);
          }
        }
      }
    } else {
      // bypass option to either continue with flow
      if (arg === "ducted") {
        structure.setSystemType("zoning-air-balancing");
        prevStep(3);
      } else if (arg === "ductless") {
        structure.setSystemType("ductless-controls");
        prevStep(2);
      } else if (arg === "reset") {
        structure.unsetSystemType();
        prevStep(1);
      } else {
        if (structure.getSystemType() === "ductless-controls") {
          prevStep(11);
        }
      }
    }
  }
  saveStructureToLocalStorage();
}

function showFloor(step, floor) {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  const floors = document.querySelectorAll(`#floor-group-${step} .floor`);
  floors.forEach((f) => f.classList.remove("active"));
  const currentFloor = document.querySelector(`#floor-group-${step} .floor[data-floor="${floor}"]`);
  if (currentFloor) {
    currentFloor.classList.add("active");
  }
}

function nextFloor(step) {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  if (floorData[step] < maxFloors) {
    floorData[step]++;
    showFloor(step, floorData[step]);
  }
}

function prevFloor(step) {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  if (floorData[step] > 1) {
    floorData[step]--;
    showFloor(step, floorData[step]);
  }
}

function prettyPrintStructure() {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  const debugDiv = document.getElementById('debug-structure-output');
  if (debugDiv !== null) {
    debugDiv.textContent = JSON.stringify(structure, undefined, 2);
  }
}

function mapGoal(buttonText) {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  const goalMapping = {
    'Making rooms more comfortable': 'Comfort',
    'Using less energy': 'Efficiency',
    'More convenient control': 'Control'
  };
  return goalMapping[buttonText] || null;
}

function handleGoalButtonClick(event) {
  if(DEBUG) {
    console.log(new Error().stack);
  }    
  const goal = mapGoal(event.target.textContent);
  if (goal) {
    structure.addGoal(goal);
    prettyPrintStructure();
    saveStructureToLocalStorage();
  }
}

function handleFloorCheckboxChange(event) {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  const checkboxes = document.querySelectorAll('#step-3 .floor-checkbox');
  const floorOrder = ['Basement', 'Floor 1', 'Floor 2', 'Floor 3', 'Attic'];
  
  checkboxes.forEach((checkbox, index) => {
    const floorName = checkbox.parentElement.textContent.trim();
    const roomDropdown = document.querySelectorAll('#step-3 select')[index];
    if (checkbox.checked) {
      roomDropdown.disabled = false;
      if(DEBUG) {
        console.log('enabling 1259 room dropdown');
      }
      // Check if the floor is already in the structure
      let floor = structure.floors.find(f => f.name === floorName);
      if (!floor) {
        floor = new models.Floor(floorName);
        structure.addFloor(floor);
      }
    } else {
      roomDropdown.disabled = true;
      if(DEBUG) {
        console.log('disabling 1268 room dropdown');
      }
      roomDropdown.value = ''; // Reset the dropdown
      roomDropdown.className = roomDropdown.className.replace('highlight', ''); // removes border around room
      const floor = structure.floors.find(f => f.name === floorName);
      if (floor) {
        structure.removeFloor(floor);
      }
    }
  });

  // Sort the floors in the structure from bottom to top
  structure.floors.sort((a, b) => floorOrder.indexOf(a.name) - floorOrder.indexOf(b.name));
  saveStructureToLocalStorage();
  setHouseImage(); // update image of house
  validateStep3(); // Validate step 3 whenever a checkbox is changed
  prettyPrintStructure();
}

function handleRoomSelectionChange(event) {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  const dropdown = event.target;
  const index = Array.from(dropdown.parentElement.parentElement.children).indexOf(dropdown.parentElement) - 1;
  const floorName = document.querySelectorAll('#step-3 .floor-checkbox')[index].parentElement.textContent.trim();
  if(DEBUG) {
    console.log(`Dropdown index: ${index}`);
    console.log(`Floor name: ${floorName}`);
  }
  
  const floor = structure.floors.find(f => f.name === floorName);
  if (floor) {
    const roomCount = parseInt(dropdown.value, 10);
    if(DEBUG) {
      console.log(`Room count: ${roomCount}`);
    }
    floor.rooms = [];
    for (let i = 1; i <= roomCount; i++) {
      floor.rooms.push(new models.Room(`Room ${i}`));
    }
    if(DEBUG) {
      console.log(`Rooms added to floor: ${JSON.stringify(floor.rooms)}`);
    }
    prettyPrintStructure();
  } else {
    console.error(`Floor not found in structure: ${floorName}`);
  }
  saveStructureToLocalStorage();
  setHouseImage(); // update image of house
  validateStep3(); // Validate step 3 whenever a room selection is changed
}

function handleDuctlessSelectionChange(event) {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  const dropdown = event.target;
  // id from the select and remove everything before the last -
  const type = dropdown.id.replace('ductless-units-dropdown-', '');
  if(DEBUG) {
    console.log(`Type: ${type}`);
  }

  // amount is the value of the selection from he dropdown
  var quantity = 0;
  if (dropdown.value !== "") {
    quantity = dropdown.value === '20+' ? 20 : parseInt(dropdown.value, 10);
  }
  if(DEBUG) {
    console.log(`Quantity: ${quantity}`);
  }

  const filteredSystems = structure.hvacSystems.filter(system => system.systemType === type);
  if(DEBUG) {
    console.log(`# Filtered: ${filteredSystems.length}`);
    console.log(filteredSystems);
  }
  if (filteredSystems.length > quantity) {
    for (let i = filteredSystems.length; i > quantity; i--) {
      structure.removeHVACSystem(filteredSystems[i - 1]);
    }
  // elif structure.hvacSystems < quantity
  } else if(filteredSystems.length < quantity) {
    for (let i = filteredSystems.length; i < quantity; i++) {
      if(DEBUG) {
        console.log(`hvacType = ${type}`);
      }
      structure.addHVACSystem(new models.HVACSystem(`${type} ${i+1}`, type));
    }
  }

  saveStructureToLocalStorage();
}

function validateStep3() {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  const nextButton = document.getElementById('next-button-step-3');
  const checkboxes = document.querySelectorAll('#step-3 .floor-checkbox:checked');
  let isValid = true;

  if (checkboxes.length === 0) {
    isValid = false;
  } else {
    checkboxes.forEach((checkbox) => {
      const index = Array.from(checkbox.parentElement.parentElement.children).indexOf(checkbox.parentElement) - 1;
      const roomDropdown = document.querySelectorAll('#step-3 select')[index];
      if (roomDropdown.value === '') {
        isValid = false;
        roomDropdown.classList.add('highlight');
      } else {
        roomDropdown.classList.remove('highlight');
      }
    });
  }

  return isValid;
}

function validateAndGlowStep3() {
  if(DEBUG) {
    console.log(new Error().stack);
    console.log('validateAndGlowStep3 called');
  }
  const isValid = validateStep3();
  const highlightedDropdowns = document.querySelectorAll('#step-3 select.highlight');
  highlightedDropdowns.forEach((dropdown) => {
    if(DEBUG) {
      console.log('Adding glow to dropdown');
    }
    dropdown.classList.add('glow');
    setTimeout(() => {
      if(DEBUG) {
        console.log('Removing glow from dropdown');
      }
      dropdown.classList.remove('glow');
    }, 2000);
  });

  if (isValid) {
    nextStep(4); // Advance to the next step if valid
  }
}

function getStepFromURL() {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  const urlParams = new URLSearchParams(window.location.search);
  const step = urlParams.get('step');
  return step ? parseInt(step, 10) : 1;
}

function setHouseImage() {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  document.querySelectorAll('#house-image').forEach(houseImage => {
    const numberOfFloors = structure.floors.length ? structure.floors.length : 1;
    const imgURL = SB_IMG_URLS[`Solution-Builder-${numberOfFloors}-Floors.min.png`];
    houseImage.setAttribute('data-src', imgURL);
    houseImage.setAttribute('src', imgURL);
  })
  updateImagePaths();
}

function setHouseImageStep9() {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  const houseImage = document.querySelector('#step-9 .sub-container.left img');
  const numberOfFloors = structure.floors.length ? structure.floors.length : 1;
  const imgURL = SB_IMG_URLS[`Solution-Builder-${numberOfFloors}-Floors-Floor-${currentFloorIndex + 1}-Highlighted.min.png`];
  houseImage.setAttribute('data-src', imgURL);
  houseImage.setAttribute('src', imgURL);
  updateImagePaths();
}

function handleEmailSubmit() {
  function analyticsUpdateSection(status='execute', msg='undefined', showEmailPopup=structure.getHomeownerEmail() === null) {
    gtag('event', 'solutionBuilder.email', {
      'status': status,
      'description': msg,
      'laststep': currentStep,
      'laststeptext': convertStepToText(currentStep),
      'nextstep': nextStepNumber,
      'nextsteptext': convertStepToText(nextStepNumber),
      'showEmailPopup': showEmailPopup,
      'email_requested_cart': structure.email_requested_cart,
      'email_requested_recommendation': structure.email_requested_recommendation,
    });
  }
  if(DEBUG) {
    console.log(new Error().stack);
  }
  if (currentStep == 10) {
    structure.email_requested_cart = true;
  } else {
    structure.email_requested_recommendation = true;
  }
  var nextStepNumber = currentStep >= 14 ? 10 : currentStep == 10 ? null : currentStep + 1;
  analyticsUpdateSection('execute');

  document.querySelectorAll('#email-input').forEach(email => {
    if (email.value.length > 0) {
      structure.setHomeownerEmail(email.value);
      prettyPrintStructure();
    }
  });

  if (structure.getHomeownerEmail() === null) {
    // use swal input to get email and then with that, do something else
    document.body.style.pointerEvents = 'auto';
    Swal.fire({
      title: 'Please enter your email to receive your cart.',
      input: 'email',
      inputAttributes: {
        'placeholder': 'your-email@example.com'
      },
      confirmButtonText: 'Send',
      showCancelButton: true,
      preConfirm: (email) => {
        if (!email) {
          Swal.showValidationMessage('Please enter a valid email address');
          analyticsUpdateSection('error', 'invalid email entered');
          return false;
        } else {
          structure.setHomeownerEmail(email);
          prettyPrintStructure();
          analyticsUpdateSection('updated', 'email updated');
          return true;
        }
      },
    }).then(res => {
      if(DEBUG) {
        console.log(JSON.stringify(res));
      }
      if (res.isConfirmed) {

        // if currentStep is > 14, it's probably step 10 that we want to use
        // if currentStep is 10 (end page), then we don't want to go anywhere
        
        if (structure.getHomeownerEmail() !== null) {
          handleKlaviyoSubmit(true, nextStepNumber);
        }
      }
    });
  } else {
    handleKlaviyoSubmit(true, nextStepNumber);
  }
}

function updateStructureVariables() {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  const shopifyCartFormatted = structure.cart_data.items.map(item => {
    var text = `${item.id}:${item.quantity}`;
    if(DEBUG) {
      console.log(text);
    }
    return text;
  }).join(',');
  if (structure.cart_data.items.length > 0) {
    structure.cart = `https://flair.co/cart/${shopifyCartFormatted}`;
  }
  structure.cg = structure.goals.join(',');
  // structure.floors[*].rooms[*].thermostats[*]['brand'] === "Nest", get the list of brands and save them as structure.thermostat with a .join(',')
  structure.thermostat = structure.floors.flatMap(floor => floor.rooms.flatMap(room => room.thermostats.map(thermostat => thermostat.brand))).join(',');
  // structure.floors[*].rooms[*].remoteSensors[*]
  const hasRemoteSensors = structure.floors.some(floor => floor.rooms.some(room => room.remoteSensors.length > 0));
  structure.room_sensors = hasRemoteSensors ? 'yes' : 'no'
  saveStructureToLocalStorage();
}

// klaviyo subscription
function subProfileKlaviyo(email, properties) {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  const options = {
    method: 'POST',
    headers: {'revision': '2024-10-15', 'content-type': 'application/vnd.api+json'},
    body: JSON.stringify({
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: properties
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: KLAVIYO_LIST
            }
          }
        }
      }
    })
  };
  
  return fetch(KLAVIYO_SUBSCRIPTION_URL, options)
}

// klaviyo update profile
function updateProfileKlaviyo(email, properties) {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  const options = {
    method: 'POST',
    headers: {'revision': '2024-10-15', 'content-type': 'application/vnd.api+json'},
    body: JSON.stringify({
      data: {
        type: "profile",
        attributes: {
          email: email,
          properties: properties
        }
      }
    })
  };
  
  return fetch(KLAVIYO_PROFILE_URL, options)
}

function handleKlaviyoSubmit(show_notifications=false, next_step=null) {
  function analyticsUpdateSection(status='execute', msg='undefined') {
    gtag('event', 'solutionBuilder.klaviyo', {
      'status': status,
      'description': msg,
      'laststep': currentStep,
      'laststeptext': convertStepToText(currentStep),
      'nextstep': next_step,
      'nextsteptext': convertStepToText(next_step),
      'show_notifications': show_notifications,
    });
  }

  function klaviyoAdditionalProperties(structure, isComplete = null, hasPurchased = null) {
    let variables = {};

    // sb_goal
    variables.sb_goal = structure.goals.join(',');

    // sb_hvac_system_types
    variables.sb_hvac_system_types = Array.from(new Set(structure.hvacSystems.map(system => system.name))).join(',');

    // sb_floors
    variables.sb_floors = Array.from(new Set(structure.floors.map(floor => floor.name))).join(',');

    // sb_rooms
    variables.sb_rooms = structure.floors.reduce((acc, floor) => {
        acc[floor.name] = floor.rooms;
        return acc;
    }, {});

    // sb_thermostats
    variables.sb_thermostats = Array.from(new Set(
        structure.floors.flatMap(floor =>
            floor.rooms.flatMap(room =>
                room.thermostats.map(thermostat => thermostat.brand)
            )
        )
    )).filter(Boolean).join(',');

    // sb_last_step
    variables.sb_last_step = currentStep;
    variables.sb_last_step_text = convertStepToText(currentStep);

    // sb_is_complete
    if (isComplete !== null) {
      variables.sb_is_complete = isComplete.toString();
    }

    // sb_has_recommendation
    variables.sb_has_recommendation = (structure.recommendation && structure.recommendation.floors.length > 0).toString();

    // sb_cart_url
    variables.sb_cart_url = structure.cart;

    // sb_has_purchased
    if (hasPurchased !== null) {
      variables.sb_has_purchased = hasPurchased.toString();
    }

    return variables;
  }

  if(DEBUG) {
    console.log(new Error().stack);
  }
  analyticsUpdateSection();
  if (structure.getHomeownerEmail() !== null) {
    // modified structure
    updateStructureVariables();

    subProfileKlaviyo(structure.homeownerEmail, { 
      ...structure, 
      ...klaviyoAdditionalProperties(structure),
      source: 'Solution Builder' 
    })
    .then(res1 => {
      if (res1.status < 200 || res1.status >= 300) {
        // analyticsUpdateSection('error', 'profile may already exists');
        throw new Error(res1.body);
      }
      analyticsUpdateSection('success', 'profile created');
      if (show_notifications) {
        Swal.fire({
          title: 'Success!',
          text: 'You will receive your recommendation via email soon.',
          icon: 'success',
          confirmButtonText: 'OK'
        })
        .then(res12 => {
          if (next_step !== null) {
            nextStep(next_step);
          }
        });
      }
    })
    .catch(err => {
      // try to update their profile instead
      updateProfileKlaviyo(structure.homeownerEmail, { 
        ...structure, 
        ...klaviyoAdditionalProperties(structure),
        source: 'Solution Builder' }
      )
      .then(res2 => {
        if (res2.status < 200 || res2.status >= 300) {
          throw new Error(res2.body);
        }
        analyticsUpdateSection('success', 'profile update');
        if (show_notifications) {
          Swal.fire({
            title: 'Success!',
            text: 'You will receive your recommendation via email soon.',
            icon: 'success',
            confirmButtonText: 'OK'
          })
          .then(res21 => {
            if (next_step !== null) {
              nextStep(next_step);
            }
          });
        }
      })
      .catch(err2 => {
        analyticsUpdateSection('error', 'profile created but could not update');
        if (show_notifications) {
          Swal.fire({
            title: 'Error!',
            text: 'There was an error processing your request. Please try again later.',
            icon: 'error',
            confirmButtonText: 'OK'
          });
        }
      });
    });
  }
}

function handleAddToCart() {
  function analyticsUpdateSection(status='execute', msg='undefined') {
    gtag('event', 'solutionBuilder.addToCart', {
      'status': status,
      'description': msg,
      'step': currentStep,
      'steptext': convertStepToText(currentStep)
    });
  }
  if(DEBUG) {
    console.log(new Error().stack);
    console.log('--- cart_data ---');
    console.log(structure.cart_data);
    console.log('-----------------');
  }

  // Check for placeholder/unavailable products
  const hasUnavailableProducts = structure.cart_data.items.some(item =>
    item.id === 'puck2-placeholder' || item.id === null || item.id === undefined
  );

  if (hasUnavailableProducts) {
    // Show warning for unavailable products
    document.body.style.pointerEvents = 'auto';
    Swal.fire({
      title: 'Product Not Available',
      html: 'Some products in your cart are not currently available. Please contact our support team for assistance.',
      icon: 'warning',
      showDenyButton: true,
      confirmButtonColor: "#ff955a",
      denyButtonColor: "#ff955a",
      confirmButtonText: 'Live Chat',
      denyButtonText: 'Email Us'
    }).then((result) => {
      if (result.isConfirmed) {
        analyticsUpdateSection('unavailable_product', 'Live Chat clicked');
        // identify user as having clicked this button
        structure.clicked_live_chat = true;
        saveStructureToLocalStorage();
        openLiveChat();
      } else if (result.isDenied) {
        analyticsUpdateSection('unavailable_product', 'Email Us clicked');
        // identify user as having clicked this button
        structure.clicked_email_us = true;
        saveStructureToLocalStorage();
        window.open(LINK_EMAIL_US, '_blank');
      }
    });
    return; // Don't proceed with cart addition
  }

  handleKlaviyoSubmit(false, null);
  // TODO: Actually add it cart instead of redirecting to checkout page with cart items
  updateStructureVariables();
  if (structure.cart.length > 1) {
    analyticsUpdateSection('success', 'redirecting user to cart');
    window.location.href = structure.cart;
  } else {
    // swal alert, issue adding items to cart
    analyticsUpdateSection('error', 'url for cart is not defined');
    Swal.fire({
      title: 'Error!',
      text: 'There was an error adding items to your cart. Please try again later.',
      icon: 'error',
      confirmButtonText: 'OK'
    });
  }
}

// Initialize the first step
document.addEventListener("DOMContentLoaded", () => {
  if(DEBUG) {
    console.log(new Error().stack);
    console.log('DOMContentLoaded...!!!');
  }

  // Remove the promptResumeOrStartOver call from here
  // Initialize floor display for steps with floors
  showFloor(4, floorData[4]);
  showFloor(5, floorData[5]);
  showFloor(9, floorData[9]);

  // Add event listener to step-1 buttons to update goals
  const step1Buttons = document.querySelectorAll('#step-1 button');
  step1Buttons.forEach(button => {
    button.addEventListener('click', handleGoalButtonClick);
  });

  // Add event listener to step-3 checkboxes to update floors
  const step3Checkboxes = document.querySelectorAll('#step-3 .floor-checkbox');
  step3Checkboxes.forEach(checkbox => {
    checkbox.checked = false;
    checkbox.addEventListener('change', handleFloorCheckboxChange);
  });

  // Add event listener to step-3 room dropdowns to update rooms
  const roomDropdowns = document.querySelectorAll('#step-3 select');
  roomDropdowns.forEach(dropdown => {
    dropdown.disabled = true; // Initially disable all dropdowns
    dropdown.value = "-";
    if(DEBUG) {
      console.log('disabling 1436 room dropdown');
    }
    dropdown.addEventListener('change', handleRoomSelectionChange);
  });

  // Add event listener to step-11 minisplit dropdowns
  const ductlessDropdowns = document.querySelectorAll('#step-11 select');
  ductlessDropdowns.forEach(dropdown => {
    dropdown.value = "";
    dropdown.addEventListener('change', handleDuctlessSelectionChange);
  });

  // Add event listener to the next button to always fire validateAndGlowStep3
  // document.getElementById('next-button-step-3').addEventListener('click', (event) => {
  //   event.preventDefault(); // Prevent the default action
  //   console.log('Next button clicked');
  //   validateAndGlowStep3();
  // });

  // Add event listener to the email submit button
  document.querySelectorAll('#submit-email').forEach(button => {
    button.addEventListener('click', (event) => {
      event.preventDefault(); // Prevent the default action

      // identify user as having clicked this button
      structure.clicked_submit_email = true;
      saveStructureToLocalStorage();

      handleEmailSubmit();
    });
  });

  // Add event listener to the add to cart button
  document.querySelectorAll('#add-to-cart').forEach(button => {
    button.addEventListener('click', (event) => {
      event.preventDefault(); // Prevent the default action

      // identify user as having clicked this button
      structure.clicked_add_to_cart = true;
      saveStructureToLocalStorage();

      handleAddToCart();
    });
  });

  // Set the house image based on the number of floors
  setHouseImage();

  const ductlessUnitsDropdown = document.getElementById('ductless-units-dropdown');
  if (ductlessUnitsDropdown) {
    ductlessUnitsDropdown.addEventListener('change', handleDuctlessUnitsSelection);
  }

  // TOOLTIPS
  populateTooltipEvents();

});


// // EXTEND DROPDOWNS OPTIONS
// function extendOptions(element_id, amount=20) {
//   console.log(element_id);
//   const dropdown = document.getElementById(element_id);
//   // make sure we haven't already created more options before we run this...
//   if (dropdown.options.length >= amount) {
//     return;
//   }
//   for (let i = 1; i <= 20; i++) {
//     const option = dropdown.createElement('option');
//     option.value = i;
//     // if last i in loop, add a +sign
//     if (i === amount) {
//       option.text = `${i}+`;
//     } else {
//       option.text = `${i}`;
//     }
//   }
// }

function generateAnalysisTable() {
  if(DEBUG) {
    console.log(new Error().stack);
    console.log(structure);
  }
  const tableBody = document.getElementById('analysis-table-body');
  tableBody.innerHTML = ''; // Clear existing content

  // header row
  const headerRow = document.createElement('tr');
  const firstCell = document.createElement('td');
  firstCell.style.textAlign = 'center';
  firstCell.style.padding = 'unset';
  headerRow.appendChild(firstCell);

  const recPuckCell = document.createElement('td');
  recPuckCell.colSpan = 1;
  const puckImageDataSrc = 'assets/Solution-Builder-Step-7-Puck-Transparent.png';
  const puckImageURL = document.querySelector(`#image-url-container img[data-src="${puckImageDataSrc}"]`).getAttribute('src');
  recPuckCell.innerHTML = `<img class='rec-product-image' src="${puckImageURL}" />`;
  recPuckCell.style.padding = 0;
  recPuckCell.style.textAlign = 'center';
  headerRow.appendChild(recPuckCell);

  const recVentCell = document.createElement('td');
  recVentCell.colSpan = 1;
  const VentImageDataSrc = 'assets/Solution-Builder-Step-7-Vent-Transparent.png';
  const VentImageURL = document.querySelector(`#image-url-container img[data-src="${VentImageDataSrc}"]`).getAttribute('src');
  recVentCell.innerHTML = `<img class='rec-product-image' src="${VentImageURL}" />`;
  recVentCell.style.padding = 0;
  recVentCell.style.textAlign = 'center';
  headerRow.appendChild(recVentCell);

  const reasonCell = document.createElement('td');
  reasonCell.colSpan = 1;
  reasonCell.textContent = 'Reasoning:';
  reasonCell.className = 'rec-reasoning-title';
  headerRow.appendChild(reasonCell);
  tableBody.appendChild(headerRow);

  //body
  structure.recommendation.floors.forEach(floor => {
    // Add floor name row
    const floorRow = document.createElement('tr');
    const floorCell = document.createElement('td');
    floorCell.textContent = floor.getName();
    floorCell.style.fontWeight = 'bold';

    floorCell.colSpan = 4;
    floorCell.style.fontWeight = 'bold';
    floorCell.style.fontSize = '1.5em';
    floorCell.style.width = '5em';
    floorRow.appendChild(floorCell);
    tableBody.appendChild(floorRow);

    // Add room rows
    floor.rooms.forEach(room => {
      const row = document.createElement('tr');
      const checkMark = `<img class="rec-check-image" src="${document.querySelector('#image-url-container img[data-src="assets/Solution-Builder-Blue-Tick.min.png"]').getAttribute('src')}" />`;
      let firstCell = '';
      let secondCell = '';

      if (room.puckCandidate) {
        firstCell = checkMark;
      } else if (room.thermostats.length > 0) {
        firstCell = `<button class="analysis-existing-device">USE EXISTING <br />THERMOSTAT</button>`;
      } else if (room.remoteSensors.length > 0) {
        firstCell = `<button class="analysis-existing-device">USE EXISTING <br />ROOM SENSOR</button>`;
      } else {
        firstCell = `<button class="analysis-ignored">•</button>`;
      }

      secondCell = room.smartVentCandidate ? checkMark : '<button class="analysis-ignored">•</button>';

      row.innerHTML = `
        <td class="rec-room-name">${room.getName()}</td>
        <td style="width: 15%; text-align: center;">${firstCell}</td>
        <td style="width: 15%; text-align: center;">${secondCell}</td>
        <td class="rec-reasoning-description">${room.getRecommendationReasoning()}</td>
      `;
      tableBody.appendChild(row);
    });
  });
}

function toggleDebugPanel() {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  // const debugPanel = document.getElementById('debug-structure-output');
  // const toggleButton = document.getElementById('toggle-debug-button');
  // if (debugPanel.classList.contains('visible')) {
  //   debugPanel.classList.remove('visible');
  //   debugPanel.classList.add('hidden');
  //   toggleButton.textContent = 'Show Debug';
  // } else {
  //   debugPanel.classList.remove('hidden');
  //   debugPanel.classList.add('visible');
  //   toggleButton.textContent = 'Hide Debug';
  // }
}

function saveStructureToLocalStorage() {
  if(DEBUG) {
    console.log(new Error().stack);
    console.log(structure);
  }
  localStorage.setItem('structure', JSON.stringify(structure));
  localStorage.setItem('lastStep', currentStep);
}

function loadStructureFromLocalStorage() {
  if(DEBUG) {
    console.log(new Error().stack);
    console.log('Attempting to load structure from localStorage...');
  }

  const savedStructureString = localStorage.getItem('structure');
  const lastStepFromStorage = parseInt(localStorage.getItem('lastStep'), 10);

  // Only proceed if saved data exists
  if (savedStructureString) {
    if(DEBUG) { console.log('Structure found in localStorage. Parsing...'); }
    let parsedStructure;
    try {
      parsedStructure = JSON.parse(savedStructureString);
      if(DEBUG) { console.log('Parsed Structure:', parsedStructure); }
    } catch (e) {
      console.error('Failed to parse structure from localStorage:', e);
      clearLocalStorage(); // Clear potentially corrupt data
      return false; // Indicate failure
    }

    // Create a new Structure instance to load data into
    structure = new models.Structure();

    // Copy top-level properties
    structure.name = parsedStructure.name;
    structure.address = parsedStructure.address;
    structure.goals = Array.isArray(parsedStructure.goals) ? parsedStructure.goals.filter(goal => models.Structure.ALLOWABLE_GOALS.includes(goal)) : [];
    structure.homeownerEmail = parsedStructure.homeownerEmail;
    structure.proEmail = parsedStructure.proEmail;

    // Rehydrate HVAC Systems
    structure.hvacSystems = Array.isArray(parsedStructure.hvacSystems) ? parsedStructure.hvacSystems.map(systemData => {
        if (systemData && systemData.name && systemData.systemType) {
             return new models.HVACSystem(systemData.name, systemData.systemType, systemData.fuelType, systemData.brand, systemData.model, systemData.supportsIntegration, systemData.supportsRemote);
        }
        console.warn('Skipping malformed HVAC system data:', systemData);
        return null;
    }).filter(system => system !== null) : [];

    // Rehydrate Floors and Rooms
    structure.floors = Array.isArray(parsedStructure.floors) ? parsedStructure.floors.map(floorData => {
      if (!floorData || !floorData.name) {
           console.warn('Skipping malformed floor data:', floorData);
           return null;
      }
      const floor = new models.Floor(floorData.name, floorData.level);

      floor.rooms = Array.isArray(floorData.rooms) ? floorData.rooms.map(roomData => {
          if (!roomData || !roomData.name) {
              console.warn('Skipping malformed room data:', roomData);
              return null;
          }
          const room = new models.Room(roomData.name, roomData.coolingBehavior, roomData.heatingBehavior);

          room.thermostats = Array.isArray(roomData.thermostats) ? roomData.thermostats.map(thermostatData => {
              if (thermostatData && thermostatData.brand) return new models.Thermostat(thermostatData.brand);
              return null;
          }).filter(t => t !== null) : [];

          room.remoteSensors = Array.isArray(roomData.remoteSensors) ? roomData.remoteSensors.map(sensorData => {
              if (sensorData && sensorData.brand) return new models.RemoteSensor(sensorData.brand);
              return null;
          }).filter(s => s !== null) : [];

          room.vent_count = roomData.vent_count;

          room.vents = Array.isArray(roomData.vents) ? roomData.vents.map(ventData => {
              const newSmartVent = new models.SmartVent();
              newSmartVent.name = ventData ? ventData.name : null;
              let savedSize = ventData ? ventData.size : "";

              if (savedSize) {
                  if (newSmartVent.ALLOWABLE_SIZES.includes(savedSize)) {
                      newSmartVent.size = savedSize;
                  } else {
                      const baseSizeMatch = newSmartVent.ALLOWABLE_SIZES.find(allowedSize => allowedSize.startsWith(savedSize));
                      if (baseSizeMatch) {
                          newSmartVent.size = baseSizeMatch;
                          if(DEBUG) { console.log(`Remapped saved vent size "${savedSize}" to "${baseSizeMatch}".`); }
                      } else {
                          newSmartVent.size = "";
                          console.warn(`Saved vent size "${savedSize}" not available/mappable. Resetting for room "${room.name}".`);
                      }
                  }
              } else {
                  newSmartVent.size = "";
              }
              return newSmartVent;
          }) : [];
          return room;
      }).filter(r => r !== null) : [];
      return floor.rooms.length > 0 || floorData.name ? floor : null; // Keep floor if it has a name, even if no rooms yet from parse
    }).filter(f => f !== null) : [];

    // Copy other state flags
    structure.email_requested_recommendation = parsedStructure.email_requested_recommendation;
    structure.email_requested_cart = parsedStructure.email_requested_cart;
    structure.solution_builder_created_at = parsedStructure.solution_builder_created_at;
    structure.clicked_live_chat = parsedStructure.clicked_live_chat;
    structure.clicked_email_us = parsedStructure.clicked_email_us;
    structure.clicked_have_questions = parsedStructure.clicked_have_questions;
    structure.clicked_submit_email = parsedStructure.clicked_submit_email;
    structure.clicked_add_to_cart = parsedStructure.clicked_add_to_cart;

    // Rehydrate Cart Data
    structure.cart_data = new models.Cart();
    if (parsedStructure.cart_data && Array.isArray(parsedStructure.cart_data.items)) {
         parsedStructure.cart_data.items.forEach(item => {
             if (item && item.id && typeof item.quantity === 'number') {
                structure.cart_data.addItem(new models.CartItem(item.id, item.quantity));
             } else {
                 console.warn('Skipping malformed cart item:', item);
             }
         });
    }

    structure.cart = parsedStructure.cart || "";
    structure.cg = parsedStructure.cg || "";
    structure.thermostat = parsedStructure.thermostat || "";
    structure.room_sensors = parsedStructure.room_sensors || "";

    // Set the current step initially from localStorage
    currentStep = !isNaN(lastStepFromStorage) ? lastStepFromStorage : 1;
    if(DEBUG) { console.log(`Initial currentStep from localStorage: ${currentStep}`); }

    // IMPORTANT: Rebuild recommendations based on the rehydrated structure
    if (structure.floors && structure.floors.length > 0) {
        if(DEBUG) { console.log('Rebuilding recommendations based on loaded structure...'); }
        structure.makeRecommendation();
        structure.makeGetStartedRecommendation();

        // Check for blank vent sizes in smartVentCandidate rooms ---
        let redirectToStep9DueToBlankVents = false;
        if (structure.recommendation && structure.recommendation.floors) {
            for (let floorIdx = 0; floorIdx < structure.recommendation.floors.length; floorIdx++) {
                const recommendedFloor = structure.recommendation.floors[floorIdx];
                // Ensure corresponding actual floor and rooms exist before accessing
                const actualFloor = structure.floors[floorIdx];

                if (recommendedFloor && actualFloor && recommendedFloor.rooms && actualFloor.rooms) {
                    for (let roomIdx = 0; roomIdx < recommendedFloor.rooms.length; roomIdx++) {
                        const recommendedRoom = recommendedFloor.rooms[roomIdx];
                        const actualRoom = actualFloor.rooms[roomIdx];

                        if (recommendedRoom && actualRoom && recommendedRoom.smartVentCandidate) {
                            // Check the vents in the *actual* structure room
                            if (actualRoom.vents && actualRoom.vents.some(vent => vent.size === "")) {
                                redirectToStep9DueToBlankVents = true;
                                if(DEBUG) { console.log(`Blank vent size found in candidate room: Floor ${actualFloor.name}, Room ${actualRoom.name}.`); }
                                break; 
                            }
                        }
                    }
                }
                if (redirectToStep9DueToBlankVents) break;
            }
        }

        if (redirectToStep9DueToBlankVents) {
            // If the user was at or past step 9 (vent input) or step 10 (recommendation),
            // and blank vents are found for necessary rooms, send them back to step 9.
            if (lastStepFromStorage >= 9) {
                currentStep = 9;
                if(DEBUG) { console.log(`Overriding currentStep to 9 due to blank vent sizes. Original lastStep from storage was ${lastStepFromStorage}.`); }
            }
        }

    } else {
         structure.recommendation = { floors: [] };
         structure.getStartedRecommendation = {};
         if(DEBUG) { console.log('No floors loaded, resetting recommendations.'); }
    }

    return true; // Indicate successful loading

  } else {
    if(DEBUG) { console.log('No structure found in localStorage.'); }
    structure = new models.Structure();
    currentStep = 1;
    return false;
  }
}

function clearLocalStorage() {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  localStorage.removeItem('structure');
  localStorage.removeItem('lastStep');
  structure = new models.Structure();
}

function promptResumeOrStartOver() {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  const savedStructure = localStorage.getItem('structure');
  if (savedStructure && !document.querySelector('.resume-popup')) { // Check if the popup already exists
    gtag('event', 'solutionBuilder.resumeOrStartOver');
    addOverlay();
    const popup = document.createElement('div');
    popup.classList.add('resume-popup'); // Changed class name to 'resume-popup'
    popup.innerHTML = `
      <p>You have a saved session. Would you like to resume or start over?</p>
      <button onclick="resumeSession()">Resume</button>
      <button onclick="startOver()">Start Over</button>
    `;
    document.querySelector('.flair-solution-builder').appendChild(popup);
  } else {
    loadStep(1);
  }
}

function resumeSession() {
  openStepper();
  if(DEBUG) {
    console.log(new Error().stack);
    console.log('Resuming session');
  }

  // Load structure. `loadStructureFromLocalStorage` will set the global `currentStep`
  // to the last saved step, or override it to 9 if necessary due to blank vents.
  loadStructureFromLocalStorage();
  const finalStepToLoad = currentStep; // Use the authoritative currentStep

  gtag('event', 'solutionBuilder.resume', {
    'laststep': finalStepToLoad,
    'laststeptext': convertStepToText(finalStepToLoad),
  });
  closeResumePopup();
  addOverlay();

  // Hide all steps first, then load the target one
  document.querySelectorAll('.step').forEach(s => {
    s.style.display = 'none';
    s.classList.remove('active');
  });
  
  // The `loadStep` function will handle displaying the correct step and calling
  // its specific population logic (e.g., populateStep9, generateFloorContentStep9).
  loadStep(finalStepToLoad);

  // For steps with floor-based content that might not be reset by loadStep's populate functions alone
  // (if `loadStep` only calls `populateStepX` which doesn't reset `currentFloorIndex`)
  // ensure currentFloorIndex is reset if landing on these specific steps.
  if (finalStepToLoad === 4 || finalStepToLoad === 5 || finalStepToLoad === 9) {
      currentFloorIndex = 0; // Reset to the first floor for these views
      // The `loadStep` function calls the populateStepX functions, which in turn
      // call generateFloorContentX(currentFloorIndex). So this reset should be effective.
      // If generateFloorContentX is not called by populateStepX within loadStep,
      // you might need to call it explicitly here:
      // if (finalStepToLoad === 4) populateStep4(); // or generateFloorContent(currentFloorIndex);
      // if (finalStepToLoad === 5) populateStep5(); // or generateFloorContentStep5(currentFloorIndex);
      // if (finalStepToLoad === 9) populateStep9(); // or generateFloorContentStep9(currentFloorIndex);
      // However, `loadStep` already calls these, so the currentFloorIndex reset should suffice.
  }
}
function renderStepsUpTo(lastStep) {
  if(DEBUG) {
    console.log(new Error().stack);
    console.log('Rendering steps up to', lastStep, 'based on structure data');
    console.log(`HAS STRUCTURE? ${structure}`);
  }
  if (lastStep >= 1) populateStep1();
  // if (lastStep >= 2) populateStep2();
  if (lastStep >= 3) populateStep3();
  if (lastStep >= 4) populateStep4();
  if (lastStep >= 5) populateStep5();
  if (lastStep >= 7) populateStep7();
  if (lastStep >= 9) populateStep9();
  if (lastStep >= 10) populateStep10();
}

function startOver() {
  gtag('event', 'solutionBuilder.startOver');
  if(DEBUG) {
    console.log(new Error().stack);
  }
  clearLocalStorage();
  loadStep(1);
  closeResumePopup();
  openStepper(); // Ensure the wizard is opened
  document.getElementById('step-1').style.display = 'flex'; // Ensure step-1 is displayed
  const steps = document.querySelectorAll('.step');
  steps.forEach(step => {
    if (step.id !== 'step-1') {
      step.style.display = 'none'; // Hide all other steps
    }
  });
}

function closeResumePopup() {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  removeOverlay();
  const popup = document.querySelector('.flair-solution-builder .resume-popup'); // Changed class name to 'resume-popup'
  if (popup) popup.remove();
}

// Attach functions to the window object to make them globally accessible
window.closeStepper = closeStepper;
window.openStepper = openStepper;
window.nextStep = nextStep;
window.prevStep = prevStep;
window.validateAndGlowStep3 = validateAndGlowStep3;
window.nextFloorOrStep = nextFloorOrStep;
window.prevFloorOrStep = prevFloorOrStep;
window.nextFloorOrStepStep5 = nextFloorOrStepStep5;
window.prevFloorOrStepStep5 = prevFloorOrStepStep5;
window.closeWarningPopup = closeWarningPopup;
window.toggleDebugPanel = toggleDebugPanel;
window.nextFloorOrStepStep9 = nextFloorOrStepStep9;
window.prevFloorOrStepStep9 = prevFloorOrStepStep9;
window.adjustQuantity = adjustQuantity;
window.closeResumePopup = closeResumePopup;
window.promptResumeOrStartOver = promptResumeOrStartOver;
window.resumeSession = resumeSession;
window.startOver = startOver;
window.closeTooltip = closeTooltip;

function renderSteps() {
  if(DEBUG) {
    console.log(new Error().stack);
    console.log('Rendering steps based on structure data');
  }
  populateStep1();
  populateStep3();
  populateStep4();
  populateStep5();
  populateStep7();
  populateStep9();
  populateStep11();
  populateStep10();
}

function populateStep1() {
  if(DEBUG) {
    console.log(new Error().stack);
    console.log('Populating Step 1');
  }
  // Populate step 1 based on the goals in the structure
  const goalButtons = document.querySelectorAll('#step-1 .goal-button');
  goalButtons.forEach(button => {
    const goal = mapGoal(button.textContent);
    if (structure.goals.includes(goal)) {
      button.classList.add('selected');
    }
  });
}

function populateStep11() {
  if(DEBUG) {
    console.log(new Error().stack);
    console.log('Populating Step 2 (aka 11)');
  }
  // remove non-ductless thermostats
  structure.hvacSystems.filter(system => system.systemType === 'forced-air').forEach(system => structure.removeHVACSystem(system));

  // reset all checkboxes on this step
  const ductlessDropdowns = document.querySelectorAll('#step-11 select');
  ductlessDropdowns.forEach(dropdown => {
    const typeFromID = dropdown.id.replace('ductless-units-dropdown-', '');
    const foundSystems = structure.hvacSystems.filter(system => system.systemType === typeFromID);
    if (foundSystems.length > 0) {
      dropdown.value = foundSystems.length < 20 ? `${foundSystems.length}` : '20';
    } else {
      dropdown.value = "";
    }
  });
}

function populateStep3() {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  const roomDropdowns = document.querySelectorAll('#step-3 select');
  if(DEBUG) {
    console.log(structure.floors);
  }

  const existingThermostats = structure.hvacSystems.filter(system => system.systemType === 'forced-air');
  if(DEBUG) {
    console.log(`existing thermostats: ${existingThermostats.length}`);
  }
  if (existingThermostats.length === 0) {
    structure.addHVACSystem(new models.HVACSystem('Ducted', 'forced-air'));
  }

  // if there are any non-ducted thermostats, remove them
  structure.hvacSystems.filter(system => system.systemType !== 'forced-air').forEach(system => structure.removeHVACSystem(system));

  // reset floors and rooms
  const step3Checkboxes = document.querySelectorAll('#step-3 .floor-checkbox');
  step3Checkboxes.forEach(checkbox => {
    // see if we already have the in our structure
    checkbox.checked = structure.floors.some(floor => floor.name === checkbox.nextSibling.data);
  });

  roomDropdowns.forEach(dropdown => {
    if(DEBUG) {
      console.log(`${dropdown.id} ${dropdown.value}`);
    }
    const floorNameFromID = dropdown.id.replace('ducted-rooms-', '').replace('-', ' ');
    var foundFloor = structure.floors.find(floor => floor.name === floorNameFromID);
    if (foundFloor) {
      if (foundFloor.rooms.length > 0) {
        dropdown.value = foundFloor.rooms.length;
        dropdown.disabled = false;
      } else {
        // disable dropdown and uncheck floor box
        dropdown.value = "";
        dropdown.disabled = true;
        step3Checkboxes.forEach(checkbox => {
          if (checkbox.nextSibling.data == floorNameFromID) {
            checkbox.checked = false;
          }
        });
        // remove floor from array if it has no rooms
        structure.floors = structure.floors.filter(floor => floor.name !== floorNameFromID);
      }
    } else {
      dropdown.value = "";
      dropdown.disabled = true; // Initially disable dropdowns
    }
  });
  setHouseImage();
}

function populateStep4() {
  if(DEBUG) {
    console.log(new Error().stack);
    console.log('Populating Step 4');
  }
  currentFloorIndex = 0;
  generateFloorContent(currentFloorIndex);
}

function populateStep5() {
  if(DEBUG) {
    console.log(new Error().stack);
    console.log('Populating Step 5');
  }
  currentFloorIndex = 0;
  generateFloorContentStep5(currentFloorIndex);
}

function populateStep7() {
  if(DEBUG) {
    console.log(new Error().stack);
    console.log('Populating Step 7');
  }
  generateAnalysisTable();
}

function populateStep9() {
  if(DEBUG) {
    console.log(new Error().stack);
    console.log('Populating Step 9');
  }
  currentFloorIndex = 0;
  generateFloorContentStep9(currentFloorIndex);
  setHouseImageStep9();
}

function populateStep10() {
  if(DEBUG) {
    console.log(new Error().stack);
    console.log('Populating Step 10');
  }
  generateRecommendationContent();
}

function loadStep(step) {
  if(DEBUG) {
    console.log(new Error().stack);
    console.log(`Loading Step ${step}`);
  }

  const currentStepElement = document.querySelector('.step.active');
  if (currentStepElement) {
    currentStepElement.classList.remove('active');
    currentStepElement.classList.add('off-screen-right');
  }

  const nextStepElement = document.getElementById(`step-${step}`);
  if (nextStepElement) {
    nextStepElement.classList.remove('off-screen-right');
    nextStepElement.classList.add('active');
    nextStepElement.style.display = 'flex';
    currentStep = step;

    // Populate steps based on the existing structure
    if (step === 1) populateStep1();
    if (step === 3) populateStep3();
    if (step === 4) populateStep4();
    if (step === 5) populateStep5();
    if (step === 7) populateStep7();
    if (step === 9) populateStep9();
    if (step === "9B") {
      // Step 9B doesn't need special population
    }
    if (step === 10) populateStep10();
    if (step === 11) populateStep11();
  }
}

function showTooltip(title, content) {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  document.body.style.pointerEvents = 'auto';
  Swal.fire({
    title: title,
    html: content,
    allowOutsideClick: false,
    showConfirmButton: false,
    showCloseButton: true,
  });
}

function closeTooltip() {
  if(DEBUG) {
    console.log(new Error().stack);
  }
  removeOverlay();
  const tooltip = document.querySelector('.flair-solution-builder .tooltip-popup');
  if (tooltip) tooltip.remove();
}